//import uiRouter from 'angular-ui-router';
var module = angular.module('app.StateModule', [
    'ui.router',
    'oc.lazyLoad'
    //import modules
]);

const stateArray = [
    {
        "_id" : "student_details",
        "name" : "Student Details"
    },
    {
        "_id" : "teacher_details",
        "name" : "Teacher Details"
    },
    {
        "_id" : "acd_inform",
        "name" : "Academics Information"
    },
    {
        "_id" : "inclusion_dept",
        "name" : "Inclusion Department"
    },
    {
        "_id" : "staff_development",
        "name" : "Staff Development"
    },
    {
        "_id" : "sports_trip_curr_activities",
        "name" : "Sports-Trip-Extra Curricular Activity"
    },
    {
        "_id" : "parent_updates",
        "name" : "Parent Updates"
    },
    {
        "_id" : "3rd_party_vendors",
        "name" : "Third Party Vendors"
    },
    {
        "_id" : "operations",
        "name" : "Operations"
    },
    {
        "_id" : "resources_updates",
        "name" : "Resources Updates"
    },
    {
        "_id" : "it_updates",
        "name" : "IT Updates"
    },
    {
        "_id" : "happiness_dept",
        "name" : "Happiness Department"
    },
    {
        "_id" : "hs_updates",
        "name" : "H&S Updates"
    },
    {
        "_id" : "procurement_updates",
        "name" : "Procurement Updates"
    },
    {
        "_id" : "school_transport",
        "name" : "School Transport"
    },
    {
        "_id" : "compliance_&_pro",
        "name" : "Compliance & Pro"
    },
    {
        "_id" : "hr_updates",
        "name" : "HR Updates"
    },
    {
        "_id" : "governance",
        "name" : "Governance"
    }
]
module.config(function($stateProvider, $urlRouterProvider, $locationProvider) {
    'ngInject';
    //$locationProvider.html5Mode(true).hashPrefix('!');
    //$locationProvider.hashPrefix('');
    //$urlRouterProvider.otherwise('/login');
    $stateProvider.state('app', {
            url: '',
            abstract: true
        })
        .state('dashboard', {
            name: 'dashboard',
            url: '/dashboard',
            parent: 'app',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/dashboard/views/dashboard.html',
                            './app/dashboard/dashboard.scss'
                        ], function() {
                            let template = require('./app/dashboard/views/dashboard.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'DashBoardController',
                    controllerAs: 'test'
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/dashboard/dashboardModule.js');
                        $ocLazyLoad.load({
                            name: 'app.DashBoardModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('menutile', {
            url: '/menutile',
            parent: 'app',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/menutile/views/menutile.html',
                            './app/menutile/menutile.scss'
                        ], function() {
                            let template = require('./app/menutile/views/menutile.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'MenuController',
                    controllerAs: 'test'
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/menutile/menutileModule.js');
                        $ocLazyLoad.load({
                            name: 'menutile'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('archives', {
            url: '/archives',
            parent: 'app',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/views/archives.html'], function() {
                            let template = require('./app/archives/views/archives.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'archives',
                    controllerAs: 'archives',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/archives/archivesModule.js');
                        $ocLazyLoad.load({
                            name: 'ArchivesModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('userManagement', {
            url: '/userEndorsement',
            parent: 'app',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/userEndorsement/views/userEndorsement.html'], function() {
                            let template = require('./app/userEndorsement/views/userEndorsement.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'userEndorsementCtrl',
                    controllerAs: 'userManagementDirective',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/userEndorsement/userEndorsementModule.js');
                        $ocLazyLoad.load({
                            name: 'userEndorsement'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('studentEndorse', {
            url: '/user-management/student-endorse',
            parent: 'userManagement',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/userEndorsement/views/studentEndorsement.html'], function() {
                            let template = require('./app/userEndorsement/views/studentEndorsement.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'stuEndrseCtrl',
                    controllerAs: 'stuEndrseCtrl'
                }
            }
        }).state('teacherEndorse', {
            url: '/user-management/teacher-endorse/:hos_supervisor',
            parent: 'userManagement',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/userEndorsement/views/teacherEndorsement.html'], function() {
                            let template = require('./app/userEndorsement/views/teacherEndorsement.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'teacherEndorsementCtrl',
                    controllerAs: 'teachrEndrsCtrl'
                }
            }
        }).state('moduleWithFeature', {
            url: '/moduleWithFeature',
            parent: 'app',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/moduleFeature/views/moduleFeature.html'], function() {
                            let template = require('./app/moduleFeature/views/moduleFeature.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'moduleFeatureCtrl',
                    controllerAs: 'test'
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/moduleFeature/moduleFeatureModules.js');
                        $ocLazyLoad.load({
                            name: 'moduleWithFeature'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('profileSetting', {
            url: '/profile-setting',
            parent: 'app',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/profileSetting/views/profileSetting.html'], function() {
                            let template = require('./app/profileSetting/views/profileSetting.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'profileSettingCtrl',
                    controllerAs: 'userMgt'
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/profileSetting/profileSettingModules.js');
                        $ocLazyLoad.load({
                            name: 'userSearchDirective'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('profileData', {
            url: '/profile-view/:person_id',
            parent: 'app',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/profileSetting/views/profileView.html'], function() {
                            let template = require('./app/profileSetting/views/profileView.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'profileViewCtrl',
                    controllerAs: 'profileViewCtrls'
                }
            }
        })
        /* .state('teacherView', {
                    url: '/teacherView',
                    parent: 'profileData',
                    views: {
                        '@': {
                            templateProvider: ['$q', function($q) {
                                let deferred = $q.defer();
                                require.ensure(['./app/profileSetting/views/teacherView.html'], function() {
                                    let template = require('./app/profileSetting/views/teacherView.html');
                                    deferred.resolve(template);
                                });
                                return deferred.promise;
                            }],
                            controller: 'teacherViewCtrl',
                            controllerAs: 'teacherView'
                        }
                    },
                    resolve: {
                        foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                            let deferred = $q.defer();
                            require.ensure([], function() {
                                let module = require('./app/profileSetting/teacherViewModule.js');
                                $ocLazyLoad.load({
                                    name: 'teacherView'
                                });
                                deferred.resolve(module);
                            });

                            return deferred.promise;
                        }]
                    }
                }).state('hodView', {
                    url: '/hodView',
                    parent: 'profileData',
                    views: {
                        '@': {
                            templateProvider: ['$q', function($q) {
                                let deferred = $q.defer();
                                require.ensure(['./app/profileSetting/views/hodView.html'], function() {
                                    let template = require('./app/profileSetting/views/hodView.html');
                                    deferred.resolve(template);
                                });
                                return deferred.promise;
                            }],
                            controller: 'hodViewCtrl',
                            controllerAs: 'hodView'
                        }
                    },
                    resolve: {
                        foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                            let deferred = $q.defer();
                            require.ensure([], function() {
                                let module = require('./app/profileSetting/hodViewModule.js');
                                $ocLazyLoad.load({
                                    name: 'hodView'
                                });
                                deferred.resolve(module);
                            });

                            return deferred.promise;
                        }]
                    }
                }).state('hosView', {
                    url: '/hosView',
                    parent: 'profileData',
                    views: {
                        '@': {
                            templateProvider: ['$q', function($q) {
                                let deferred = $q.defer();
                                require.ensure(['./app/profileSetting/views/hosView.html'], function() {
                                    let template = require('./app/profileSetting/views/hosView.html');
                                    deferred.resolve(template);
                                });
                                return deferred.promise;
                            }],
                            controller: 'hosViewCtrl',
                            controllerAs: 'hosView'
                        }
                    },
                    resolve: {
                        foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                            let deferred = $q.defer();
                            require.ensure([], function() {
                                let module = require('./app/profileSetting/hosViewModule.js');
                                $ocLazyLoad.load({
                                    name: 'hosView'
                                });
                                deferred.resolve(module);
                            });

                            return deferred.promise;
                        }]
                    }
                }).state('parentView', {
                    url: '/parentView',
                    parent: 'profileData',
                    views: {
                        '@': {
                            templateProvider: ['$q', function($q) {
                                let deferred = $q.defer();
                                require.ensure(['./app/profileSetting/views/parentView.html'], function() {
                                    let template = require('./app/profileSetting/views/parentView.html');
                                    deferred.resolve(template);
                                });
                                return deferred.promise;
                            }],
                            controller: 'parentViewCtrl',
                            controllerAs: 'parentView',
                        }
                    },
                    resolve: {
                        foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                            let deferred = $q.defer();
                            require.ensure([], function() {
                                let module = require('./app/profileSetting/parentViewModule.js');
                                $ocLazyLoad.load({
                                    name: 'parentView'
                                });
                                deferred.resolve(module);
                            });

                            return deferred.promise;
                        }]
                    }
                }) */
        /* .state('navigation', {
                    name: 'navigation',
                    url: '/navigation',
                    views: {
                        '@': {

                            templateProvider: ['$q', function($q) {
                                let deferred = $q.defer();
                                require.ensure(['./app/navigation/views/navigation.html'], function() {
                                    let template = require('./app/navigation/views/navigation.html');
                                    deferred.resolve(template);
                                });
                                return deferred.promise;
                            }],
                            controller: 'navigationCtrl',
                            controllerAs: 'navigation'
                        }
                    },
                    resolve: {
                        foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                            let deferred = $q.defer();
                            require.ensure([], function() {
                                let module = require('./app/dashboard/dashboardModule.js');
                                $ocLazyLoad.load({
                                    name: 'app.navigation'
                                });
                                deferred.resolve(module);
                            });

                            return deferred.promise;
                        }]
                    }
                }) */
        .state('archivesPreview', {
            parent: 'app',
            url: '/archives-preview',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/archives/preview/archivesPreviewModule.js');
                        $ocLazyLoad.load({
                            name: 'ArchivesPreviewModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            },
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/preview/views/preview.html'], function() {
                            let template = require('./app/archives/preview/views/preview.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'archivesPreviewCtrl',
                    controllerAs: 'archivesPreview'
                }
            }
        }).state('resourcePreview', {
            parent: 'archivesPreview',
            url: '/resource-preview/:id',
            views: {
                'archivePreview': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/preview/views/resources.html'], function() {
                            let template = require('./app/archives/preview/views/resources.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'resourcesCtrl',
                    controllerAs: 'resources',
                }
            }
        })
        .state('syllabusPreview', {
            parent: 'archivesPreview',
            url: '/syllabus-preview/:id',
            views: {
                'archivePreview': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/preview/views/syllabus.html'], function() {
                            let template = require('./app/archives/preview/views/syllabus.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'syllabusCtrl',
                    controllerAs: 'syllabus'
                }
            }
        }).state('notesPreview', {
            parent: 'archivesPreview',
            url: '/notes-preview/:id',
            views: {
                'archivePreview': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/preview/views/notes.html'], function() {
                            let template = require('./app/archives/preview/views/notes.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'notesCtrl',
                    controllerAs: 'notes'
                }
            }
        }).state('teachingPlanPreview', {
            parent: 'archivesPreview',
            url: '/teaching-plan-preview/:id',
            views: {
                'archivePreview': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/preview/views/tp.html'], function() {
                            let template = require('./app/archives/preview/views/tp.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controllerAs: "tp",
                    controller: "tpCtrl"
                }
            }

        }).state('questionPreview', {
            parent: 'archivesPreview',
            url: '/question-preview/:id',
            views: {
                'archivePreview': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/preview/views/question.html'], function() {
                            let template = require('./app/archives/preview/views/question.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controllerAs: "question",
                    controller: 'questionCtrl',
                }
            }
        }).state('qpPreview', {
            parent: 'archivesPreview',
            url: '/qp-preview/:id',
            views: {
                'archivePreview': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/preview/views/qp.html'], function() {
                            let template = require('./app/archives/preview/views/qp.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controllerAs: "qp",
                    controller: "qpCtrl"
                }
            }
        }).state('qpTemplatePreview', {
            parent: 'archivesPreview',
            url: '/qp-template-preview/:id',
            views: {
                'archivePreview': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/preview/views/qpTemplate.html'], function() {
                            let template = require('./app/archives/preview/views/qpTemplate.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controllerAs: "qpTemplate",
                    controller: "qpTemplateCtrl"
                }
            }
        }).state('myArchives', {
            parent: 'app',
            url: '/my-archives',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/myArchives/views/myArchives.html'], function() {
                            let template = require('./app/archives/myArchives/views/myArchives.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'myArchivesCtrl',
                    controllerAs: 'myArchives',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/archives/myArchives/myArchivesModule.js');
                        $ocLazyLoad.load({
                            name: 'MyArchivesModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('sendForApprovalArchive', {
            parent: 'app',
            url: '/archives/send-for-approval',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/myArchives/views/sendForApproval.html'], function() {
                            let template = require('./app/archives/myArchives/views/sendForApproval.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controllerAs: "sendForApproval",
                    controller: "sendForApprovalCtrl"
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/archives/myArchives/myArchivesModule.js');
                        $ocLazyLoad.load({
                            name: 'MyArchivesModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('approveArchive', {
            parent: 'app',
            url: '/archives/approve',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/myArchives/views/approve.html'], function() {
                            let template = require('./app/archives/myArchives/views/approve.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controllerAs: "approve",
                    controller: "approveCtrl"
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/archives/myArchives/myArchivesModule.js');
                        $ocLazyLoad.load({
                            name: 'MyArchivesModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('publishArchive', {
            parent: 'app',
            url: '/archives/publish-contents',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/publishArchives/views/publish.html'], function() {
                            let template = require('./app/archives/publishArchives/views/publish.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controllerAs: "publish",
                    controller: "publishCtrl",
                }
            },

            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/archives/publishArchives/publishArchivesModule.js');
                        $ocLazyLoad.load({
                            name: 'PublishArchivesModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('rejectedArchive', {
            parent: 'app',
            url: '/archives/rejected-contents',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/publishArchives/views/rejected.html'], function() {
                            let template = require('./app/archives/publishArchives/views/rejected.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controllerAs: "rejected",
                    controller: "rejectedCtrl"
                }
            },

        }).state('linkThemes', {
            parent: 'app',
            url: '/link-themes',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/linkThemes/views/linkTheme.html'], function() {
                            let template = require('./app/archives/linkThemes/views/linkTheme.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "linkThemeCtrl",
                    controllerAs: 'linkTheme',
                }
            },

            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/archives/linkThemes/linkThemeModule.js');
                        $ocLazyLoad.load({
                            name: 'LinkThemeModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        }).state('createArchiveItem', {
            parent: 'app',
            url: '/create-archive',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/archives/create/views/create.html'], function() {
                            let template = require('./app/archives/create/views/create.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "createCtrl",
                    controllerAs: 'create',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/archives/create/archiveCreateModule.js');
                        $ocLazyLoad.load({
                            name: 'CreateArchiveModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('curriculumEndorsement', {
            parent: 'app',
            url: '/reEndorsement',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/reEndorsement/views/reEndorsement.html'], function() {
                            let template = require('./app/reEndorsement/views/reEndorsement.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "reEndorsementCtrl",
                    controllerAs: 'reEndorseDirective',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/reEndorsement/reEndorsementModule.js');
                        $ocLazyLoad.load({
                            name: 'ReEndorseModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('toDo', {
            parent: 'app',
            url: '/myplanner/todo',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/toDo/views/toDo.html'], function() {
                            let template = require('./app/toDo/views/toDo.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "toDoCtrl",
                    controllerAs: 'toDo',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/toDo/toDoModule.js');
                        $ocLazyLoad.load({
                            name: 'ToDoModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('chat', {
            parent: 'app',
            url: '/chatPage',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/chat/views/chatPage.html'], function() {
                            let template = require('./app/chat/views/chatPage.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "ChatPageCtrl",
                    controllerAs: 'chatPageList',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/chat/chatModule.js');
                        $ocLazyLoad.load({
                            name: 'ChatModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('bookmark', {
            parent: 'app',
            url: '/bookmark',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/bookmark/views/bookmark.html'], function() {
                            let template = require('./app/bookmark/views/bookmark.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "bookmark",
                    controllerAs: 'bookmark',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/bookmark/bookmarkModule.js');
                        $ocLazyLoad.load({
                            name: 'BookmarkModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('faq', {
            parent: 'app',
            url: '/faq',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/faq/views/faq.html'], function() {
                            let template = require('./app/faq/views/faq.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "faqCtrl",
                    controllerAs: 'faqCtrl',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/faq/faqModule.js');
                        $ocLazyLoad.load({
                            name: 'FAQModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })

    .state('recieverFeedbackList', {
            parent: 'app',
            url: '/feedback/list/reciever',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/feedback/views/recieverFeedbackList.html'], function() {
                            let template = require('./app/feedback/views/recieverFeedbackList.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "recieverFeedbackListCtrl",
                    controllerAs: 'recieverFeedbackListCtrl',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/feedback/feedbackModule.js');
                        $ocLazyLoad.load({
                            name: 'FeedbackModule',
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('createFeedback', {
            parent: 'app',
            url: '/feedback/create',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/feedback/views/feedbackCreate.html'], function() {
                            let template = require('./app/feedback/views/feedbackCreate.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "feedbackCreateCtrl",
                    controllerAs: 'feedbackCreateCtrl',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/feedback/feedbackModule.js');
                        $ocLazyLoad.load({
                            name: 'FeedbackModule',
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('parentFeedback', {
            parent: 'app',
            url: '/feedback/list/parent',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/feedback/views/parentFeedbackList.html'], function() {
                            let template = require('./app/feedback/views/parentFeedbackList.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "parentFeedbackListCtrl",
                    controllerAs: 'parentFeedbackCtrl',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/feedback/feedbackModule.js');
                        $ocLazyLoad.load({
                            name: 'FeedbackModule',
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('forumList', {
            parent: 'app',
            url: '/forum',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/forum/views/forum.html'], function() {
                            let template = require('./app/forum/views/forum.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "forumCtrl",
                    controllerAs: 'forum',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/forum/forumModule.js');
                        $ocLazyLoad.load({
                            name: 'ForumModule',
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('setTarget', {
            url: '/set-target',
            parent: 'app',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/set_target/views/setTarget.html'], function() {
                            let template = require('./app/set_target/views/setTarget.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: 'setTargetCtrl',
                    controllerAs: 'SetTargetModule',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/set_target/setTargetModule.js');
                        $ocLazyLoad.load({
                            name: 'SetTargetModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('reports', {
            url: '/reports',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/reports/views/reports.html'], function() {
                    let template = require('./app/reports/views/reports.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'reports',
            controllerAs: 'reports',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/reports/reportsModule.js');
                        $ocLazyLoad.load({
                            name: 'reports'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentReport', {
            url: '/student-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/studentReport.html'], function() {
                    let template = require('./app/result-analysis/views/studentReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentReport',
            controllerAs: 'studentReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentsProgressionReport', {
            url: '/students-progression-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/studentsProgressionReport.html'], function() {
                    let template = require('./app/result-analysis/views/studentsProgressionReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentsProgressionReport',
            controllerAs: 'studentsProgressionReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('subjectWiseProgressionReport', {
            url: '/subject-wise-progression-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/subjectWiseProgressionReport.html'], function() {
                    let template = require('./app/result-analysis/views/subjectWiseProgressionReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'subjectWiseProgressionReport',
            controllerAs: 'subjectWiseProgressionReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('examWiseProgressionReport', {
            url: '/exam-wise-progression-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/examWiseProgressionReport.html'], function() {
                    let template = require('./app/result-analysis/views/examWiseProgressionReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'examWiseProgressionReport',
            controllerAs: 'examWiseProgressionReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('batchPerformanceGradeReport', {
            url: '/batch-performance-grade-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/batchPerformanceGradeReport.html'], function() {
                    let template = require('./app/result-analysis/views/batchPerformanceGradeReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'batchPerformanceGradeReport',
            controllerAs: 'batchPerformanceGradeReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('batchPerformanceMarkReport', {
            url: '/batch-performance-mark-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/batchPerformanceMarkReport.html'], function() {
                    let template = require('./app/result-analysis/views/batchPerformanceMarkReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'batchPerformanceMarkReport',
            controllerAs: 'batchPerformanceMarkReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('batchWiseProgressionReport', {
            url: '/batch-wise-progression-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/batchWiseProgressionReport.html'], function() {
                    let template = require('./app/result-analysis/views/batchWiseProgressionReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'batchWiseProgressionReport',
            controllerAs: 'batchWiseProgressionReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classPerformanceGradeReport', {
            url: '/class-performance-grade-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/classPerformanceGradeReport.html'], function() {
                    let template = require('./app/result-analysis/views/classPerformanceGradeReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classPerformanceGradeReport',
            controllerAs: 'classPerformanceGradeReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classPerformanceMarkReport', {
            url: '/class-performance-mark-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/classPerformanceMarkReport.html'], function() {
                    let template = require('./app/result-analysis/views/classPerformanceMarkReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classPerformanceMarkReport',
            controllerAs: 'classPerformanceMarkReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classWiseProgressionReport', {
            url: '/class-wise-progression-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/classWiseProgressionReport.html'], function() {
                    let template = require('./app/result-analysis/views/classWiseProgressionReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classWiseProgressionReport',
            controllerAs: 'classWiseProgressionReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('sectionPerformanceGradeReport', {
            url: '/section-performance-grade-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/sectionPerformanceGradeReport.html'], function() {
                    let template = require('./app/result-analysis/views/sectionPerformanceGradeReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'sectionPerformanceGradeReport',
            controllerAs: 'sectionPerformanceGradeReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('sectionPerformanceMarkReport', {
            url: '/section-performance-mark-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/sectionPerformanceMarkReport.html'], function() {
                    let template = require('./app/result-analysis/views/sectionPerformanceMarkReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'sectionPerformanceMarkReport',
            controllerAs: 'sectionPerformanceMarkReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('sectionWiseProgressionReport', {
            url: '/section-wise-progression-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/sectionWiseProgressionReport.html'], function() {
                    let template = require('./app/result-analysis/views/sectionWiseProgressionReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'sectionWiseProgressionReport',
            controllerAs: 'sectionWiseProgressionReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('genderWiseProgressionGradeReport', {
            url: '/gender-wise-progression-grade-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/genderWiseProgressionGradeReport.html'], function() {
                    let template = require('./app/result-analysis/views/genderWiseProgressionGradeReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'genderWiseProgressionGradeReport',
            controllerAs: 'genderWiseProgressionGradeReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('genderWiseProgressionMarkReport', {
            url: '/gender-wise-progression-mark-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/genderWiseProgressionMarkReport.html'], function() {
                    let template = require('./app/result-analysis/views/genderWiseProgressionMarkReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'genderWiseProgressionMarkReport',
            controllerAs: 'genderWiseProgressionMarkReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('consolidatedReport', {
            url: '/consolidated-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/consolidatedReport.html'], function() {
                    let template = require('./app/result-analysis/views/consolidatedReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'consolidatedReport',
            controllerAs: 'consolidatedReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('consolidatedExamReport', {
            url: '/consolidated-exam-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/result-analysis/views/consolidatedExamReport.html'], function() {
                    let template = require('./app/result-analysis/views/consolidatedExamReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'consolidatedExamReport',
            controllerAs: 'consolidatedExamReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/result-analysis/resultAnalysisModule.js');
                        $ocLazyLoad.load({
                            name: 'resultAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('announcements', {
            url: '/announcements',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/announcements/views/announcements.html'], function() {
                    let template = require('./app/announcements/views/announcements.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'announcements',
            controllerAs: 'announcements',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/announcements/announcementsModule.js');
                        $ocLazyLoad.load({
                            name: 'announcements'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('announcementsUsers', {
            url: '/announcementsUsers',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/announcements/views/announcements-users.html'], function() {
                    let template = require('./app/announcements/views/announcements-users.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'announcementsUsers',
            controllerAs: 'announcementsUsers',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/announcements/announcementsModule.js');
                        $ocLazyLoad.load({
                            name: 'announcements'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createAnnouncements', {
            url: '/create-announcements',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/announcements/views/create-announcements.html'], function() {
                    let template = require('./app/announcements/views/create-announcements.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createAnnouncements',
            controllerAs: 'createAnnouncements',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/announcements/announcementsModule.js');
                        $ocLazyLoad.load({
                            name: 'announcements'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewAnnouncements', {
            url: '/view-announcements/:announceId/:send_by',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/announcements/views/view-announcements.html'], function() {
                    let template = require('./app/announcements/views/view-announcements.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewAnnouncements',
            controllerAs: 'viewAnnouncements',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/announcements/announcementsModule.js');
                        $ocLazyLoad.load({
                            name: 'announcements'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('addAvailability', {
            url: '/addAvailability',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/my_appointments/views/set_appointment.html'], function() {
                    let template = require('./app/my_appointments/views/set_appointment.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'SetAppointmentController',
            controllerAs: 'SetAppointmentController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/my_appointments/myAppointmentsModule.js');
                        $ocLazyLoad.load({
                            name: 'SetAppointmentModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('getAvailability', {
            url: '/getAvailability',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/my_appointments/views/get_appointment.html'], function() {
                    let template = require('./app/my_appointments/views/get_appointment.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'GetAppointmentController',
            controllerAs: 'GetAppointmentController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/my_appointments/myAppointmentsModule.js');
                        $ocLazyLoad.load({
                            name: 'GetAppointmentModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('attendanceReport', {
            url: '/attendance_report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/attendance_report/views/attendance_report.html'], function() {
                    let template = require('./app/attendance_report/views/attendance_report.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'AttendanceReportController',
            controllerAs: 'AttendanceReportController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/attendance_report/attendanceReportModule.js');
                        $ocLazyLoad.load({
                            name: 'attendance_report'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('datewiseAttReport', {
            url: '/datewiseAttReport',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/attendance_report/views/datewiseReport.html'], function() {
                    let template = require('./app/attendance_report/views/datewiseReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'DatewiseAttReportController',
            controllerAs: 'DatewiseAttReportController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/attendance_report/attendanceReportModule.js');
                        $ocLazyLoad.load({
                            name: 'attendance_report'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('cpdSections', {
            url: '/cpd-sections',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cpd/views/cpdSections.html'], function() {
                    let template = require('./app/cpd/views/cpdSections.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'cpdSections',
            controllerAs: 'cpdSections',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cpd/cpdModule.js');
                        $ocLazyLoad.load({
                            name: 'cpdSections'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('addCpd', {
            url: '/add-cpd',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cpd/views/addCpd.html'], function() {
                    let template = require('./app/cpd/views/addCpd.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'addCpd',
            controllerAs: 'addCpd',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cpd/cpdModule.js');
                        $ocLazyLoad.load({
                            name: 'cpdSections'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('cpdPublish', {
            url: '/cpd-publish/:cpd_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cpd/views/cpdPublish.html'], function() {
                    let template = require('./app/cpd/views/cpdPublish.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'cpdPublish',
            controllerAs: 'cpdPublish',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cpd/cpdModule.js');
                        $ocLazyLoad.load({
                            name: 'cpdSections'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('attnd-list', {
            url: '/attendance',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/attendance/views/attendance.html'], function() {
                    let template = require('./app/attendance/views/attendance.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'AttendanceController',
            controllerAs: 'AttendanceController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/attendance/attendanceModule.js');
                        $ocLazyLoad.load({
                            name: 'attendance'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('attendance', {
            url: '/take_attendance',
            params: {
                resource: '',
                from: ''
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/attendance/views/take_attendance.html'], function() {
                    let template = require('./app/attendance/views/take_attendance.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'TakeAttendanceController',
            controllerAs: 'TakeAttendanceController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/attendance/takeAttendanceModule.js');
                        $ocLazyLoad.load({
                            name: 'take_attendance'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('attendanceconsole', {
            url: '/attendance_console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/attendance_console/views/attendance_console.html'], function() {
                    let template = require('./app/attendance_console/views/attendance_console.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'AttendanceConsoleController',
            controllerAs: 'AttendanceConsoleController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/attendance_console/attendanceConsoleModule.js');
                        $ocLazyLoad.load({
                            name: 'attendance_console'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('reassignAvailability', {
            url: '/reassignAvailability',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/my_appointments/views/reassign_appointment.html'], function() {
                    let template = require('./app/my_appointments/views/reassign_appointment.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ReassignAppointmentController',
            controllerAs: 'ReassignAppointmentController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/my_appointments/myAppointmentsModule.js');
                        $ocLazyLoad.load({
                            name: 'ReassignAppointmentModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('myProfile', {
            url: '/my-profile',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/my-profile/views/myProfile.html'], function() {
                    let template = require('./app/my-profile/views/myProfile.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'myProfile',
            controllerAs: 'myProfile',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/my-profile/myProfileModule.js');
                        $ocLazyLoad.load({
                            name: 'myProfile'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('editProfile', {
            url: '/edit-profile',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/my-profile/views/editProfile.html'], function() {
                    let template = require('./app/my-profile/views/editProfile.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'editProfile',
            controllerAs: 'editProfile',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/my-profile/myProfileModule.js');
                        $ocLazyLoad.load({
                            name: 'myProfile'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('changePassword', {
            url: '/change-password',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/change-password/views/changePassword.html'], function() {
                    let template = require('./app/change-password/views/changePassword.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'changePassword',
            controllerAs: 'changePassword',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/change-password/changePasswordModule.js');
                        $ocLazyLoad.load({
                            name: 'changePassword'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('attendanceLite', {
            url: '/attendance-lite',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/attendanceLite/views/attendanceLiteView.html'], function() {
                    let template = require('./app/attendanceLite/views/attendanceLiteView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'attendanceLite',
            controllerAs: 'attendanceLite',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/attendanceLite/attendanceLiteModule.js');
                        $ocLazyLoad.load({
                            name: 'AttendanceLiteModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('notifications', {
            url: '/notifications',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/notifications/views/notifications.html'], function() {
                    let template = require('./app/notifications/views/notifications.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'notifications',
            controllerAs: 'notifications',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/notifications/notificationsModule.js');
                        $ocLazyLoad.load({
                            name: 'notifications'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('contentSummary', {
            url: '/content-summary',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/content-summary/views/contentSummary.html'], function() {
                    let template = require('./app/content-summary/views/contentSummary.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'contentSummary',
            controllerAs: 'contentSummary',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/content-summary/contentSummaryModule.js');
                        $ocLazyLoad.load({
                            name: 'contentSummary'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('calendarTask', {
            url: '/calendar-task:redirect',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/calendar/views/calendar.html'], function() {
                    let template = require('./app/calendar/views/calendar.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'calendarTask',
            controllerAs: 'calendarTask',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/calendar/calendarModule.js');
                        $ocLazyLoad.load({
                            name: 'calendarTask'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('attendancePreview', {
            url: '/my-attendance',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/attendance/views/studentAttendancePreview.html'], function() {
                    let template = require('./app/attendance/views/studentAttendancePreview.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'StudentAttendancePreview',
            controllerAs: 'StudentAttendancePreview',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/attendance/studentAttendancePreviewModule.js');
                        $ocLazyLoad.load({
                            name: 'student_attendance'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('myTimetable', {
            url: '/my-timetable',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/my_timetable/views/my_timetable.html'], function() {
                    let template = require('./app/my_timetable/views/my_timetable.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'MyTimetablePreview',
            controllerAs: 'MyTimetablePreview',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/my_timetable/myTimetableModule.js');
                        $ocLazyLoad.load({
                            name: 'my_timetable'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('timetableconsole', {
            url: '/timetable_console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/timetable_console/views/timetable_console.html'], function() {
                    let template = require('./app/timetable_console/views/timetable_console.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'TimetableConsoleController',
            controllerAs: 'TimetableConsoleController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/timetable_console/timetableConsoleModule.js');
                        $ocLazyLoad.load({
                            name: 'timetable_console'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })

        .state('leaveManagement', {
            url: '/leave_management',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/leaveManagement/views/leaveManagement.html'], function() {
                    let template = require('./app/leaveManagement/views/leaveManagement.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'leaveManagement',
            controllerAs: 'leaveManagement',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/leaveManagement/leaveManagementModule.js');
                        $ocLazyLoad.load({
                            name: 'LeaveManagementModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })

        .state('createLeave', {
            url: '/create-leave/:parent_state/:user_id/',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/leaveManagement/views/createleave.html'], function() {
                    let template = require('./app/leaveManagement/views/createleave.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createLeaveController',
            controllerAs: 'createLeaveController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/leaveManagement/leaveManagementModule.js');
                        $ocLazyLoad.load({
                            name: 'LeaveManagementModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('timetableallocation', {
            url: '/timetable_allocation',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/timetable_allocation/views/timetable_allocation.html'], function() {
                    let template = require('./app/timetable_allocation/views/timetable_allocation.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'TimetableAllocationController',
            controllerAs: 'TimetableAllocationController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/timetable_allocation/timetableAllocationModule.js');
                        $ocLazyLoad.load({
                            name: 'timetable_allocation'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('createUserManual', {
            url: '/create-user-manual',
            params: {
                um_id: null,
                feature_id: null
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/userManual/views/createUserManual.html'], function() {
                    let template = require('./app/userManual/views/createUserManual.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createUserManual',
            controllerAs: 'createUserManual',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/userManual/userManualModule.js');
                        $ocLazyLoad.load({
                            name: 'UserManual'

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewUserManual', {
            url: '/view-user-manual',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/userManual/views/viewUserManual.html'], function() {
                    let template = require('./app/userManual/views/viewUserManual.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewUserManual',
            controllerAs: 'viewUserManual',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/userManual/userManualModule.js');
                        $ocLazyLoad.load({
                            name: 'UserManual'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('removeUser', {
            url: '/deactivate_users',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/deactivateUsers/views/deactivateUsers.html'], function() {
                    let template = require('./app/deactivateUsers/views/deactivateUsers.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'DeactivateUsersCtrlController',
            controllerAs: 'userManagementDirective',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/deactivateUsers/deactivateUsersModule.js');
                        $ocLazyLoad.load({
                            name: 'deactivateUsers'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('criteriaConsole', {
            url: '/criteria-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/fpi/views/criteriaConsole.html'], function() {
                    let template = require('./app/fpi/views/criteriaConsole.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'criteriaConsole',
            controllerAs: 'criteriaConsole',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/fpi/fpiModule.js');
                        $ocLazyLoad.load({
                            name: 'fpi'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('criteriaScheduler', {
            url: '/criteria-scheduler',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/fpi/views/criteriaScheduler.html'], function() {
                    let template = require('./app/fpi/views/criteriaScheduler.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'criteriaScheduler',
            controllerAs: 'criteriaScheduler',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/fpi/fpiModule.js');
                        $ocLazyLoad.load({
                            name: 'fpi'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })

        .state('markEntryProgress', {
            url: '/mark-entry-progress',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/dashboard_reports/views/markEntryProgress.html'], function() {
                    let template = require('./app/dashboard_reports/views/markEntryProgress.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'markEntryProgress',
            controllerAs: 'markEntryProgress',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/dashboard_reports/dashBoardReportModule.js');
                        $ocLazyLoad.load({
                            name: 'DashboardReport'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('teachingPlanReport', {
            url: '/teaching-plan-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/dashboard_reports/views/teachingPlanProgress.html'], function() {
                    let template = require('./app/dashboard_reports/views/teachingPlanProgress.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'teachingPlanReport',
            controllerAs: 'teachingPlanReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/dashboard_reports/dashBoardReportModule.js');
                        $ocLazyLoad.load({
                            name: 'DashboardReport'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('dailyAttendenceReport', {
            url: '/daily-attendence-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/dashboard_reports/views/dailyAttendenceReport.html'], function() {
                    let template = require('./app/dashboard_reports/views/dailyAttendenceReport.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'dailyAttendenceReport',
            controllerAs: 'dailyAttendenceReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/dashboard_reports/dashBoardReportModule.js');
                        $ocLazyLoad.load({
                            name: 'DashboardReport'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('trackActivityReport', {
            url: '/track-activity-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/dashboard_reports/views/trackActivityReport.html'], function() {
                    let template = require('./app/dashboard_reports/views/trackActivityReport.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'trackActivityReport',
            controllerAs: 'trackActivityReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/dashboard_reports/dashBoardReportModule.js');
                        $ocLazyLoad.load({
                            name: 'DashboardReport'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('loginTrackerReport', {
            url: '/login-tracker-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/dashboard_reports/views/loginTrackerReport.html'], function() {
                    let template = require('./app/dashboard_reports/views/loginTrackerReport.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'loginTrackerReport',
            controllerAs: 'loginTrackerReport',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/dashboard_reports/dashBoardReportModule.js');
                        $ocLazyLoad.load({
                            name: 'DashboardReport'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('rimsData', {
            url: '/rims-settings',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/rims-settings/views/rimsData.html'], function() {
                    let template = require('./app/rims-settings/views/rimsData.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'rimsData',
            controllerAs: 'rimsData',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/rims-settings/rimsModule.js');
                        $ocLazyLoad.load({
                            name: 'rimsData'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('rimsConsole', {
            url: '/rims-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/rims-settings/views/console.html'], function() {
                    let template = require('./app/rims-settings/views/console.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'rimsConsole',
            controllerAs: 'rimsConsole',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/rims-settings/rimsModule.js');
                        $ocLazyLoad.load({
                            name: 'rimsData'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('newTeachingPlan', {
            url: '/new-teaching-plan/:id/:planId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/teachingPlan/views/createTeachingPlan.html'], function() {
                    let template = require('./app/authoring-tool/teachingPlan/views/createTeachingPlan.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'tpController',
            controllerAs: 'newTeachingPlan',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/teachingPlan/controllers/createTeachingPlanController.js');
                        $ocLazyLoad.load({
                            name: 'newTeachingPlan'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewTeachingPlan', {
            url: '/view-teaching-plan/:planId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/teachingPlan/views/viewTeachingPlan.html'], function() {
                    let template = require('./app/authoring-tool/teachingPlan/views/viewTeachingPlan.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'tpViewController',
            controllerAs: 'viewTeachingPlan',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/teachingPlan/controllers/viewTeachingPlanController.js');
                        $ocLazyLoad.load({
                            name: 'viewTeachingPlan'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('wizard', {
            url: '/wizard/:planId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/wizard/views/wizard.html'], function() {
                    let template = require('./app/authoring-tool/wizard/views/wizard.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'wizardController',
            controllerAs: 'wizard',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/wizard/controllers/wizard.js');
                        $ocLazyLoad.load({
                            name: 'wizard'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('sendConsole', {
            url: '/sen/send-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/sendConsole.html'], function() {
                    let template = require('./app/send/views/sendConsole.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'sendConsoleCtrl',
            controllerAs: 'sendConsoleCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('send', {
            url: '/sen/dashboard-page',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/sendDashboardPage.html'], function() {
                    let template = require('./app/send/views/sendDashboardPage.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'sendDashboard',
            controllerAs: 'sendDashboard',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createSendForms', {
            url: '/sen/create-send-forms',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/createSendForms.html'], function() {
                    let template = require('./app/send/views/createSendForms.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createSendForms',
            controllerAs: 'createSendForms',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('chooseApprover', {
            url: '/sen/choose-approver/:id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/chooseApprover.html'], function() {
                    let template = require('./app/send/views/chooseApprover.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'chooseApprover',
            controllerAs: 'chooseApprover',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('commonSurveyList', {
            url: '/common-survey-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/common-survey/views/commonSurvey.html'], function() {
                    let template = require('./app/common-survey/views/commonSurvey.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'commonSurveyList',
            controllerAs: 'commonSurveyList',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/common-survey/commonSurveyModule.js');
                        $ocLazyLoad.load({
                            name: 'commonSurveyList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('surveyList', {
            url: '/survey-list/:user_id/:schedule_id/:is_fpi_survey',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/more-options/survey/views/surveyList.html'], function() {
                    let template = require('./app/authoring-tool/more-options/survey/views/surveyList.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'surveyList',
            controllerAs: 'surveyList',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/authoring-tool/more-options/survey/surveyModule.js');
                        $ocLazyLoad.load({
                            name: 'surveyList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createSurvey', {
            url: '/create-survey/:parent_state/:user_id/:schedule_id/:is_fpi_survey',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/more-options/survey/views/createSurvey.html'], function() {
                    let template = require('./app/authoring-tool/more-options/survey/views/createSurvey.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createSurvey',
            controllerAs: 'createSurvey',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/authoring-tool/more-options/survey/surveyModule.js');
                        $ocLazyLoad.load({
                            name: 'surveyList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('conductSurvey', {
            url: '/conduct-survey/:id/:parent_state/:user_id/:schedule_id/:is_fpi_survey',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/more-options/survey/views/conductSurvey.html'], function() {
                    let template = require('./app/authoring-tool/more-options/survey/views/conductSurvey.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'conductSurvey',
            controllerAs: 'conductSurvey',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/authoring-tool/more-options/survey/surveyModule.js');
                        $ocLazyLoad.load({
                            name: 'surveyList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('attemptSurvey', {
            url: '/attempt-survey/:surveyId/:parent_state/:user_id/:schedule_id/:is_fpi_survey',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/more-options/survey/views/attemptSurvey.html'], function() {
                    let template = require('./app/authoring-tool/more-options/survey/views/attemptSurvey.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'attemptSurvey',
            controllerAs: 'attemptSurvey',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/authoring-tool/more-options/survey/surveyModule.js');
                        $ocLazyLoad.load({
                            name: 'surveyList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('listSurveyAnswer', {
            url: '/list-survey-answer/:surveyId/:parent_state/:user_id/:schedule_id/:is_fpi_survey',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/more-options/survey/views/listSurveyAnswer.html'], function() {
                    let template = require('./app/authoring-tool/more-options/survey/views/listSurveyAnswer.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'listSurveyAnswer',
            controllerAs: 'listSurveyAnswer',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/authoring-tool/more-options/survey/surveyModule.js');
                        $ocLazyLoad.load({
                            name: 'surveyList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewMySubmittedSurveyAnswer', {
            url: '/view-my-submitted-survey-answer/:surveyId/:userId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/more-options/survey/views/viewMySubmittedSurveyAnswer.html'], function() {
                    let template = require('./app/authoring-tool/more-options/survey/views/viewMySubmittedSurveyAnswer.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewMySubmittedSurveyAnswer',
            controllerAs: 'viewMySubmittedSurveyAnswer',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/authoring-tool/more-options/survey/surveyModule.js');
                        $ocLazyLoad.load({
                            name: 'surveyList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewSurveyAnswer', {
            url: '/view-survey-answer/:surveyId/:userId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/more-options/survey/views/viewSurveyAnswer.html'], function() {
                    let template = require('./app/authoring-tool/more-options/survey/views/viewSurveyAnswer.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewSurveyAnswer',
            controllerAs: 'viewSurveyAnswer',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/authoring-tool/more-options/survey/surveyModule.js');
                        $ocLazyLoad.load({
                            name: 'surveyList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('manageReportCards', {
            url: '/manage-report-cards',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/manage_reports/views/manage-list.html'], function() {
                    let template = require('./app/report_cards/manage_reports/views/manage-list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'manageReportCards',
            controllerAs: 'manageReportCardsCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/manage_reports/controllers/managelistController.js');
                        $ocLazyLoad.load({
                            name: 'ManageReportsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('publishReports', {
            url: '/publish-reports',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/publish_reports/views/publishReport.html'], function() {
                    let template = require('./app/report_cards/publish_reports/views/publishReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'publishReports',
            controllerAs: 'publishReportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/publish_reports/controllers/publishReportController.js');
                        $ocLazyLoad.load({
                            name: 'publishReports'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('approveReports', {
            url: '/report-card-approvals',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/approve_reports/views/approve-reports.html'], function() {
                    let template = require('./app/report_cards/approve_reports/views/approve-reports.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'approveReports',
            controllerAs: 'reportCardApprovalCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/approve_reports/controllers/approveReportsController.js');
                        $ocLazyLoad.load({
                            name: 'ApproveReportsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('consoleSetting', {
            url: '/console-setting',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/console-settings/views/consoleSettings.html'], function() {
                    let template = require('./app/console-settings/views/consoleSettings.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'consoleSetting',
            controllerAs: 'consoleSetting',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/console-settings/consoleSettingsModule.js');
                        $ocLazyLoad.load({
                            name: 'consoleSetting'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('wifiConsole', {
            url: '/wifi-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/console-settings/views/wifiConsole.html'], function() {
                    let template = require('./app/console-settings/views/wifiConsole.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'wifiConsole',
            controllerAs: 'wifiConsole',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/console-settings/consoleSettingsModule.js');
                        $ocLazyLoad.load({
                            name: 'consoleSetting'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('adminConsole', {
            url: '/admin-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/console-settings/views/adminConsole.html'], function() {
                    let template = require('./app/console-settings/views/adminConsole.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'adminConsole',
            controllerAs: 'adminConsole',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/console-settings/consoleSettingsModule.js');
                        $ocLazyLoad.load({
                            name: 'consoleSetting'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewDetails', {
            url: '/view-details',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/console-settings/views/viewDetails.html'], function() {
                    let template = require('./app/console-settings/views/viewDetails.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewDetails',
            controllerAs: 'viewDetails',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/console-settings/consoleSettingsModule.js');
                        $ocLazyLoad.load({
                            name: 'consoleSetting'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewTabletDetails', {
            url: '/view-tablet-details',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/console-settings/views/viewTabletDetails.html'], function() {
                    let template = require('./app/console-settings/views/viewTabletDetails.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewTabletDetails',
            controllerAs: 'viewTabletDetails',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/console-settings/consoleSettingsModule.js');
                        $ocLazyLoad.load({
                            name: 'consoleSetting'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('appListConsole', {
            url: '/app-list-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/console-settings/views/appListConsole.html'], function() {
                    let template = require('./app/console-settings/views/appListConsole.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'appListConsole',
            controllerAs: 'appListConsole',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/console-settings/consoleSettingsModule.js');
                        $ocLazyLoad.load({
                            name: 'consoleSetting'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('parentPortalHome', {
            url: '/parent-portal',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/parent-portal/views/parentPortal.html'], function() {
                    let template = require('./app/parent-portal/views/parentPortal.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'parentPortalHome',
            controllerAs: 'parentPortal',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/parent-portal/parentPortalModule.js');
                        $ocLazyLoad.load({
                            name: 'ParentPortalModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentActivity', {
            url: '/student-activity',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/parent-portal/views/studentActivity.html'], function() {
                    let template = require('./app/parent-portal/views/studentActivity.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentActivity',
            controllerAs: 'studentActivity',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/parent-portal/parentPortalModule.js');
                        $ocLazyLoad.load({
                            name: 'ParentPortalModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('tabletDetailsofChild', {
            url: '/device-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/parent-portal/views/tabletDetailsofChild.html'], function() {
                    let template = require('./app/parent-portal/views/tabletDetailsofChild.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'tabletDetailsofChild',
            controllerAs: 'tabletDetailsofChild',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/parent-portal/parentPortalModule.js');
                        $ocLazyLoad.load({
                            name: 'ParentPortalModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('parentFees', {
            url: '/parent-fees',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/parent-portal/views/parentFees.html'], function() {
                    let template = require('./app/parent-portal/views/parentFees.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'parentFees',
            controllerAs: 'parentFees',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/parent-portal/parentPortalModule.js');
                        $ocLazyLoad.load({
                            name: 'ParentPortalModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('parentLibrary', {
            url: '/parent-library',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/parent-portal/views/parentLibrary.html'], function() {
                    let template = require('./app/parent-portal/views/parentLibrary.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'parentLibrary',
            controllerAs: 'parentLibrary',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/parent-portal/parentPortalModule.js');
                        $ocLazyLoad.load({
                            name: 'ParentPortalModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('trackSchoolBus', {
            url: '/track-school-bus',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/parent-portal/views/trackSchoolBus.html'], function() {
                    let template = require('./app/parent-portal/views/trackSchoolBus.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'trackSchoolBus',
            controllerAs: 'trackSchoolBus',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/parent-portal/parentPortalModule.js');
                        $ocLazyLoad.load({
                            name: 'ParentPortalModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('reportCardListing', {
            url: '/report-card-teacher-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/teacher/views/reportcard_list.html'], function() {
                    let template = require('./app/report_cards/teacher/views/reportcard_list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'reportCardListing',
            controllerAs: 'reportCardListingCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/teacher/controllers/reportcardController.js');
                        $ocLazyLoad.load({
                            name: 'ReportCardListsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('reportCardGenConsole', {
            url: '/report-card-gen-console/:cardId/:dataId/:re_generate/:fromCt',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/teacher/generation/views/report-card-console.html'], function() {
                    let template = require('./app/report_cards/teacher/generation/views/report-card-console.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'reportCardGenConsole',
            controllerAs: 'reportCardGenConsoleCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/teacher/generation/controllers/reportcardController.js');
                        $ocLazyLoad.load({
                            name: 'reportCardGenConsoleModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentListingForReports', {
            url: '/student-list-class-teacher',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/class_teacher/views/ct_reports.html'], function() {
                    let template = require('./app/report_cards/class_teacher/views/ct_reports.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentListingForReports',
            controllerAs: 'reportCardClassTeacherCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/class_teacher/controllers/classteacherController.js');
                        $ocLazyLoad.load({
                            name: 'reportCardClassTeacher'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('publishedReports', {
            url: '/published-reports/:student_id/:fee_status',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/published_reports/views/publishedReport.html'], function() {
                    let template = require('./app/report_cards/published_reports/views/publishedReport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'publishedReports',
            controllerAs: 'publishedReportsListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/published_reports/controllers/publishedReportController.js');
                        $ocLazyLoad.load({
                            name: 'PublishedReportModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })

    .state('studentParentMapping', {
        url: '/studentParentMapping',
        templateProvider: ['$q', function($q) {
            let deferred = $q.defer();
            require.ensure(['./app/student_mapping/views/student-parent-mapping.html'], function() {
                let template = require('./app/student_mapping/views/student-parent-mapping.html');
                deferred.resolve(template);
            });
            return deferred.promise;
        }],
        controller: 'studentParentMapping',
        controllerAs: 'studentParentMapping',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                let deferred = $q.defer();
                require.ensure([], function() {
                    let module = require('./app/student_mapping/controllers/mappingController.js');
                    $ocLazyLoad.load({
                        name: 'studentParentMapping'
                    });
                    deferred.resolve(module);
                });
                return deferred.promise;
            }]
        }
    })

    .state('peopleSearch', {
        url: '/people-search',
        templateProvider: ['$q', function($q) {
            let deferred = $q.defer();
            require.ensure(['./app/people_lookup/views/people-search.html'], function() {
                let template = require('./app/people_lookup/views/people-search.html');
                deferred.resolve(template);
            });
            return deferred.promise;
        }],
        controller: 'peopleSearch',
        controllerAs: 'peopleSearch',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                let deferred = $q.defer();
                require.ensure([], function() {
                    let module = require('./app/people_lookup/controllers/peoplelookupController.js');
                    $ocLazyLoad.load({
                        name: 'peopleSearch'
                    });
                    deferred.resolve(module);
                });
                return deferred.promise;
            }]
        }
    })

    .state('examListingPage', {
            url: '/examListingPage',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/list/views/markEntryListView.html'], function() {
                    let template = require('./app/mark_entry/list/views/markEntryListView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'examListingPage',
            controllerAs: 'resultEntryCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry/list/markEntryListModule.js');
                        $ocLazyLoad.load({
                            name: 'MarkEntryListModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('examMarkEntry', {
            url: '/examMarkEntry',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/save/views/markEntrySaveView.html'], function() {
                    let template = require('./app/mark_entry/save/views/markEntrySaveView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'examMarkEntry',
            controllerAs: 'resultEntryCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry/save/markEntrySaveModule.js');
                        $ocLazyLoad.load({
                            name: 'MarkEntrySaveModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classteacherApproval', {
            url: '/class-teacher-approval',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/approver/views/list.html'], function() {
                    let template = require('./app/mark_entry/approver/views/list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classteacherApproval',
            controllerAs: 'EndrosementListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry/approver/approveModule.js');
                        $ocLazyLoad.load({
                            name: 'classteacherApproval'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        }).state('academicPerformance', {
            url: '/academic-performance',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/school/views/class_average.html'], function() {
                    let template = require('./app/educore_reports/school/views/class_average.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'academicPerformance',
            controllerAs: 'academicPerformance',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/school/controllers/classaverageController.js');
                        $ocLazyLoad.load({
                            name: 'academicPerformance'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('termDifference', {
            url: '/term-difference',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/school/views/classaverage_difference.html'], function() {
                    let template = require('./app/educore_reports/school/views/classaverage_difference.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'termDifference',
            controllerAs: 'termDifference',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/school/controllers/classaveragedifferenceController.js');
                        $ocLazyLoad.load({
                            name: 'termDifference'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('attentionNeedingStudents', {
            url: '/attention-needing-students',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/school/views/needing_attention.html'], function() {
                    let template = require('./app/educore_reports/school/views/needing_attention.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'attentionNeedingStudents',
            controllerAs: 'attentionNeedingStudents',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/school/controllers/attentionneedingController.js');
                        $ocLazyLoad.load({
                            name: 'attentionNeedingStudents'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('performingSection', {
            url: '/performing-section',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/school/views/performing_section.html'], function() {
                    let template = require('./app/educore_reports/school/views/performing_section.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'performingSection',
            controllerAs: 'performingSection',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/school/controllers/performingsectionController.js');
                        $ocLazyLoad.load({
                            name: 'performingSection'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('sectionWiseAttention', {
            url: '/section-wise-attention',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/school/views/sectionwise_attention.html'], function() {
                    let template = require('./app/educore_reports/school/views/sectionwise_attention.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'sectionWiseAttention',
            controllerAs: 'sectionWiseAttention',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/school/controllers/sectionwiseattentionController.js');
                        $ocLazyLoad.load({
                            name: 'sectionWiseAttention'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentFilteration', {
            url: '/student-filteration',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/inidividual/views/student-list.html'], function() {
                    let template = require('./app/educore_reports/inidividual/views/student-list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentFilteration',
            controllerAs: 'activityReportCardCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/inidividual/controllers/controller.js');
                        $ocLazyLoad.load({
                            name: 'studentFilteration'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classActivityReportCard', {
            url: '/class-activity-report-card',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/class/views/subject_report.html'], function() {
                    let template = require('./app/educore_reports/class/views/subject_report.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classActivityReportCard',
            controllerAs: 'classActivityReportCardCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/class/controllers/controller.js');
                        $ocLazyLoad.load({
                            name: 'classActivityReportcard'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('educoreStandardReport', {
            url: '/educore-standard-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/standard/views/subject_report.html'], function() {
                    let template = require('./app/educore_reports/standard/views/subject_report.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'educoreStandardReport',
            controllerAs: 'standardreportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/standard/controllers/controller.js');
                        $ocLazyLoad.load({
                            name: 'educoreStandardReport'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('educorePerformanceAnalysis', {
            url: '/educore-performance-analysis',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/performance_analysis/views/performance_analysis.html'], function() {
                    let template = require('./app/educore_reports/performance_analysis/views/performance_analysis.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'educorePerformanceAnalysis',
            controllerAs: 'educorePerformanceAnalysisCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/performance_analysis/controllers/controller.js');
                        $ocLazyLoad.load({
                            name: 'educorePerformanceAnalysis'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('myCumulativeReport', {
            url: '/my-cumulative-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/educore_reports/cumulative/views/student-list.html'], function() {
                    let template = require('./app/educore_reports/cumulative/views/student-list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'myCumulativeReport',
            controllerAs: 'myCumulativeReportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/educore_reports/cumulative/controllers/controller.js');
                        $ocLazyLoad.load({
                            name: 'myCumulativeReport'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('clubPost', {
            url: '/club-post',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/club_activity/views/club-post.html'], function() {
                    let template = require('./app/club_activity/views/club-post.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],

            controller: 'clubPost',
            controllerAs: 'clubPost',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/club_activity/controllers/clubpostController.js');
                        $ocLazyLoad.load({
                            name: 'clubPost'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createClub', {
            url: '/create-club',
            params: {
                "user_privilege": null,
                "club_id": null,
                "mode": null
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/club_activity/views/create-club.html'], function() {
                    let template = require('./app/club_activity/views/create-club.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createClub',
            controllerAs: 'createClub',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/club_activity/controllers/createclubController.js');
                        $ocLazyLoad.load({
                            name: 'createClub'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('curriculumConsole', {
            url: '/curriculum-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/initialSettings/curriculumConsole/views/curriculumConsole.html'], function() {
                    let template = require('./app/initialSettings/curriculumConsole/views/curriculumConsole.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'curriculumConsole',
            controllerAs: 'curriculumCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/initialSettings/curriculumConsole/controllers/curriculumConsoleController.js');
                        $ocLazyLoad.load({
                            name: 'CurriculumConsoleModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('basicSettings', {
            url: '/basicSetting',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/initial_settings/views/basicSettings.html'], function() {
                    let template = require('./app/initial_settings/views/basicSettings.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'basicSettings',
            controllerAs: 'basicSettings',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/initial_settings/basicSettingsModule.js');
                        $ocLazyLoad.load({
                            name: 'basicSettings'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('curriculumSetup', {
            url: '/curriculum-setup',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/utilities/curriculumSetup/views/curriculumSetupView.html'], function() {
                    let template = require('./app/utilities/curriculumSetup/views/curriculumSetupView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'curriculumSetup',
            controllerAs: 'curriculumSetupController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/utilities/curriculumSetup/controllers/curriculumSetupController.js');
                        $ocLazyLoad.load({
                            name: 'CurriculumSetupModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('subjectSetup', {
            url: '/subject-setup',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/utilities/subjectSetup/views/subjectSetup.html'], function() {
                    let template = require('./app/utilities/subjectSetup/views/subjectSetup.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'subjectSetup',
            controllerAs: 'subjectSettingsCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/utilities/subjectSetup/controllers/subjectSetupController.js');
                        $ocLazyLoad.load({
                            name: 'SubjectSetupModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('sessionSetup', {
            url: '/session-setup',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/utilities/sessionSetup/views/sessionSetup.html'], function() {
                    let template = require('./app/utilities/sessionSetup/views/sessionSetup.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],

            controller: 'sessionSetup',
            controllerAs: 'sessionSettingsCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/utilities/sessionSetup/controllers/sessionSetupController.js');
                        $ocLazyLoad.load({
                            name: 'SessionSetupModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('adminAddNewUserInGoogle', {
            url: '/add-new-user',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/add_user/views/addUser.html'], function() {
                    let template = require('./app/add_user/views/addUser.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'addUser',
            controllerAs: 'addUser',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/add_user/addUserModule.js');
                        $ocLazyLoad.load({
                            name: 'addUser'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('editUser', {
            url: '/edit-user',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/edit_user/views/edituser.html'], function() {
                    let template = require('./app/edit_user/views/edituser.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],

            controller: 'editUser',
            controllerAs: 'editUser',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/edit_user/edituserModule.js');
                        $ocLazyLoad.load({
                            name: 'editUser'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('assignSenPerson', {
            url: '/sen/assign-senperson/:id',
            params: {
                'id': null
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/assignSenPerson.html'], function() {
                    let template = require('./app/send/views/assignSenPerson.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'assignSenPerson',
            controllerAs: 'assignSenPerson',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('changeWave', {
            url: '/sen/change-wave',
            params: {
                'id': null
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/changeWave.html'], function() {
                    let template = require('./app/send/views/changeWave.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'changeWave',
            controllerAs: 'changeWave',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createIep', {
            url: '/sen/createiep/:iep_id/:new_iep',
            params: {
                'iep_id': null,
                'new_iep': null
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/createIEP.html'], function() {
                    let template = require('./app/send/views/createIEP.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createIep',
            controllerAs: 'createIep',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createIlp', {
            url: '/sen/createilp/:ilp_id/:new_ilp',
            params: {
                'ilp_id': null,
                'new_ilp': null
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/createILP.html'], function() {
                    let template = require('./app/send/views/createILP.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createIlp',
            controllerAs: 'createIlp',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewHistoryIep', {
            url: '/sen/viewHistoryIep/:old_id/:id',
            params: {
                'old_id': null,
                'id': null
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/viewHistoryIEP.html'], function() {
                    let template = require('./app/send/views/viewHistoryIEP.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewHistoryIep',
            controllerAs: 'viewHistoryIep',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewHistoryIlp', {
            url: '/sen/viewHistoryIlp',
            params: {
                'old_id': null,
                'id': null
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/send/views/viewHistoryILP.html'], function() {
                    let template = require('./app/send/views/viewHistoryILP.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewHistoryIlp',
            controllerAs: 'viewHistoryIlp',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/send/sendModule.js');
                        $ocLazyLoad.load({
                            name: 'send'

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('giftedTalented', {
            url: '/giftedTalented/dashboard-page',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/giftedTalented/views/g&tDashboard.html'], function() {
                    let template = require('./app/giftedTalented/views/g&tDashboard.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'giftedTalented',
            controllerAs: 'giftedTalented',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/giftedTalented/giftedModule.js');
                        $ocLazyLoad.load({
                            name: 'giftedTalented'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createGiftedTalentedForms', {
            url: '/giftedTalented/create-gifted-talented-forms',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/giftedTalented/views/createGiftedTalentedForms.html'], function() {
                    let template = require('./app/giftedTalented/views/createGiftedTalentedForms.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createGiftedTalentedForms',
            controllerAs: 'createGiftedTalentedForms',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/giftedTalented/giftedModule.js');
                        $ocLazyLoad.load({
                            name: 'giftedTalented'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })

    .state('chooseApproverForGifted', {
            url: '/giftedTalented/chooseApprover',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/giftedTalented/views/chooseApprover.html'], function() {
                    let template = require('./app/giftedTalented/views/chooseApprover.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],

            controller: 'chooseApprover',
            controllerAs: 'chooseApprover',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/giftedTalented/giftedModule.js');
                        $ocLazyLoad.load({
                            name: 'giftedTalented'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('authdashboard', {
            url: '/authDashboard',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/views/authDashboard.html'], function() {
                    let template = require('./app/authoring-tool/views/authDashboard.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'authDashboardCtrl',
            controllerAs: 'authDashboardCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/authoring-tool/controllers/authDashboardController.js');
                        $ocLazyLoad.load({
                            name: 'authDashboardCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('authoringTool', {
            url: '/authoring-tool',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/views/authOverview.html'], function() {
                    let template = require('./app/authoring-tool/views/authOverview.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'authOverviewCtrl',
            controllerAs: 'authOverviewCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/controllers/authOverviewController.js');
                        $ocLazyLoad.load({
                            name: 'authOverviewCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('theme-summary', {
            url: '/theme-summary/:theme_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/views/themeSummary.html'], function() {
                    let template = require('./app/authoring-tool/views/themeSummary.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'themeSummaryCtrl',
            controllerAs: 'themeSummaryCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/controllers/themeSummaryController.js');
                        $ocLazyLoad.load({
                            name: 'themeSummaryCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('subjectReport', {
            url: '/subject-report/:studentId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/views/subjectReport.html'], function() {
                    let template = require('./app/authoring-tool/views/subjectReport.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'subjectReportCtrl',
            controllerAs: 'subjectReportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/controllers/subjectReport.js');
                        $ocLazyLoad.load({
                            name: 'subjectReportCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('subjectStudent', {
            url: '/subject-student',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/views/subjectStudentListing.html'], function() {
                    let template = require('./app/authoring-tool/views/subjectStudentListing.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'subjectStudentCtrl',
            controllerAs: 'subjectStudentCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/controllers/subjectStudentListing.js');
                        $ocLazyLoad.load({
                            name: 'subjectStudentCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        // .state('createAlp', {
        //     url: '/gifted-talented/createalp/:alp_id/:new_alp',
        //     templateProvider: ['$q', function ($q) {
        //         let deferred = $q.defer();
        //         require.ensure(['./app/giftedTalented/views/createALP.html'], function () {
        //             let template = require('./app/giftedTalented/views/createALP.html');
        //             deferred.resolve(template);
        //         });
        //         return deferred.promise;
        //     }],
        //     controller: 'createAlp',
        //     controllerAs: 'createAlp',
        //     resolve: {
        //         foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
        //             let deferred = $q.defer();
        //             require.ensure([], function () {
        //                 let module = require('./app/giftedTalented/giftedModule.js');
        //                 $ocLazyLoad.load({
        //                     name: 'giftedTalented'
        //                 });
        //                 deferred.resolve(module);
        //             });
        //             return deferred.promise;
        //         }]
        //     }
        // })
        .state('createQuestion', {
            url: '/createQuestion',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/createQuestion/views/createQuestion.html'], function() {
                    let template = require('./app/createQuestion/views/createQuestion.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createQuestionCtrl',
            controllerAs: 'createQuestionCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/createQuestion/controllers/createQuestionController.js');
                        $ocLazyLoad.load({
                            name: 'createQuestionCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('activityList', {
            url: '/activity-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/activityList.html'], function() {
                    let template = require('./app/traditionalActivity/views/activityList.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'activityListCtrl',
            controllerAs: 'activityListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/activityList.js');
                        $ocLazyLoad.load({
                            name: 'activityListCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('reportsMainCtrl', {
            url: '/traditional-activity-reports/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/reports-main.html'], function() {
                    let template = require('./app/traditionalActivity/views/reports-main.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'reportsMainCtrl',
            controllerAs: 'reportsMainCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/reports-main.js');
                        $ocLazyLoad.load({
                            name: 'reportsMainCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('individualStudentTraditionalReportCtrl', {
            url: '/traditional-activity-reports/student/:qpId/:student_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/individual-student-report.html'], function() {
                    let template = require('./app/traditionalActivity/views/individual-student-report.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'individualStudentTraditionalReportCtrl',
            controllerAs: 'individualStudentTraditionalReportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/individual-student-report.js');
                        $ocLazyLoad.load({
                            name: 'individualStudentTraditionalReportCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createActivity', {
            url: '/create-activity/:qpId/:activityId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/createActivity.html'], function() {
                    let template = require('./app/traditionalActivity/views/createActivity.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createActivityCtrl',
            controllerAs: 'createActivityCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/createActivity.js');
                        $ocLazyLoad.load({
                            name: 'createActivityCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('qpSummary', {
            url: '/qp-summary/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/qpSummary.html'], function() {
                    let template = require('./app/traditionalActivity/views/qpSummary.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'qpSummaryCtrl',
            controllerAs: 'qpSummaryCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/qpSummary.js');
                        $ocLazyLoad.load({
                            name: 'qpSummaryCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('formatQuestion', {
            url: '/format-question/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/formatQuestion.html'], function() {
                    let template = require('./app/traditionalActivity/views/formatQuestion.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'formatQuestionCtrl',
            controllerAs: 'formatQuestionCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/formatQuestion.js');
                        $ocLazyLoad.load({
                            name: 'formatQuestionCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('activityPreview', {
            url: '/activity-preview/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/activityPreview.html'], function() {
                    let template = require('./app/traditionalActivity/views/activityPreview.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'activityPreviewCtrl',
            controllerAs: 'activityPreviewCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/activityPreview.js');
                        $ocLazyLoad.load({
                            name: 'activityPreviewCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewSubmissionList', {
            url: '/submission-list/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/viewSubmissionList.html'], function() {
                    let template = require('./app/traditionalActivity/views/viewSubmissionList.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewSubmissionListCtrl',
            controllerAs: 'viewSubmissionListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/viewSubmissionList.js');
                        $ocLazyLoad.load({
                            name: 'viewSubmissionListCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('assignStudents', {
            url: '/assign-students/:qpId',
            params: {
                previousState: {}
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/assignStudents.html'], function() {
                    let template = require('./app/traditionalActivity/views/assignStudents.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'assignStudentsCtrl',
            controllerAs: 'assignStudentsCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/assignStudents.js');
                        $ocLazyLoad.load({
                            name: 'assignStudentsCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createStudentGroup', {
            url: '/assign-students/:qpId',
            params: {
                previousState: {}
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/createGroup.html'], function() {
                    let template = require('./app/traditionalActivity/views/createGroup.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createStudentGroupCtrl',
            controllerAs: 'createStudentGroupCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/createGroup.js');
                        $ocLazyLoad.load({
                            name: 'createStudentGroupCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentAnswerView', {
            url: '/student-answer-view/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/studentAnswerView.html'], function() {
                    let template = require('./app/traditionalActivity/views/studentAnswerView.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentAnswerViewCtrl',
            controllerAs: 'studentAnswerViewCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/studentAnswerView.js');
                        $ocLazyLoad.load({
                            name: 'studentAnswerViewCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('teacherAnswerView', {
            url: '/teacher-answer-view/:qpId/:studentId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/teacherAnswerView.html'], function() {
                    let template = require('./app/traditionalActivity/views/teacherAnswerView.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'teacherAnswerViewCtrl',
            controllerAs: 'teacherAnswerViewCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/teacherAnswerView.js');
                        $ocLazyLoad.load({
                            name: 'teacherAnswerViewCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentAttendingPage', {
            url: '/student-attending-page/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/studentAttendingPage.html'], function() {
                    let template = require('./app/traditionalActivity/views/studentAttendingPage.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentAttendingCtrl',
            controllerAs: 'studentAttendingCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/studentAttendingPage.js');
                        $ocLazyLoad.load({
                            name: 'studentAttendingCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentQuestionSelection', {
            url: '/student-question-selection/:qpId/:activityId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/studentQuestionSelection.html'], function() {
                    let template = require('./app/traditionalActivity/views/studentQuestionSelection.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentQuestionCtrl',
            controllerAs: 'studentQuestionCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/studentQuestionSelection.js');
                        $ocLazyLoad.load({
                            name: 'studentQuestionCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentViewReport', {
            url: '/student-view-report/:qpId/:studentId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/studentViewReport.html'], function() {
                    let template = require('./app/traditionalActivity/views/studentViewReport.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentViewReportCtrl',
            controllerAs: 'studentViewReportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/studentQuestionSelection.js');
                        $ocLazyLoad.load({
                            name: 'studentViewReportCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('teacherViewReport', {
            url: '/teacher-view-report/:qpId/:studentId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/teacherViewReport.html'], function() {
                    let template = require('./app/traditionalActivity/views/teacherViewReport.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'teacherViewReportCtrl',
            controllerAs: 'teacherViewReportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/teacherViewReport.js');
                        $ocLazyLoad.load({
                            name: 'teacherViewReportCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('attendeeList', {
            url: '/attendee-list/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/attendeeList.html'], function() {
                    let template = require('./app/traditionalActivity/views/attendeeList.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'attendeeListCtrl',
            controllerAs: 'attendeeListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/attendeeList.js');
                        $ocLazyLoad.load({
                            name: 'attendeeListCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('assignUsers', {
            url: '/assign-users/:planId',
            params: {
                previousState: {
                    state: '',
                    params: {}
                }
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/assignUsers/views/assignUsers.html'], function() {
                    let template = require('./app/authoring-tool/assignUsers/views/assignUsers.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'assignController',
            controllerAs: 'assignController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/assignUsers/controllers/assignUserController.js');
                        $ocLazyLoad.load({
                            name: 'assignController'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createGroup', {
            url: '/create-group/:planId/:groupId',
            params: {
                previousState: {}
            },
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/authoring-tool/assignUsers/views/groupCreation.html'], function() {
                    let template = require('./app/authoring-tool/assignUsers/views/groupCreation.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'groupController',
            controllerAs: 'groupController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/authoring-tool/assignUsers/controllers/groupCreationController.js');
                        $ocLazyLoad.load({
                            name: 'groupController'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('aboutUs', {
            url: '/about_us',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/about_us/views/aboutUs.html'], function() {
                    let template = require('./app/about_us/views/aboutUs.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'aboutUs',
            controllerAs: 'aboutUs',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/about_us/aboutUsModule.js');
                        $ocLazyLoad.load({
                            name: 'aboutUs'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('forgotPassword', {
            url: '/forgot-password',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/forgotPassword/views/forgot-password.html'], function() {
                    let template = require('./app/forgotPassword/views/forgot-password.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'forgotPassword',
            controllerAs: 'forgotPassword',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/forgotPassword/forgotPasswordModule.js');
                        $ocLazyLoad.load({
                            name: 'forgotPasswordModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('resetPassword', {
            url: '/cordova/reset-password/:tokenId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/reset-password/views/reset-password.html'], function() {
                    let template = require('./app/reset-password/views/reset-password.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'resetPassword',
            controllerAs: 'resetPassword',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/reset-password/resetPasswordModule.js');
                        $ocLazyLoad.load({
                            name: 'resetPasswordModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('transferStudent', {
            url: '/transfer-student',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/transfer-student/views/transferStudent.html'], function() {
                    let template = require('./app/transfer-student/views/transferStudent.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'transferStudent',
            controllerAs: 'transferStudent',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/transfer-student/transferStudentModule.js');
                        $ocLazyLoad.load({
                            name: 'transferStudent'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createImmunization', {
            url: '/create-form',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/createImmunizationForm.html'], function() {
                    let template = require('./app/medical/views/createImmunizationForm.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createFormCtrl',
            controllerAs: 'createFormCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/createImmunizationForm.js');
                        $ocLazyLoad.load({
                            name: 'createFormCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('medicalFeatureList', {
            url: '/medical-feature-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/medicalFeatureList.html'], function() {
                    let template = require('./app/medical/views/medicalFeatureList.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'featureListCtrl',
            controllerAs: 'featureListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/medicalFeatureList.js');
                        $ocLazyLoad.load({
                            name: 'featureListCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('incidents', {
            url: '/incidents/:patientId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/incidents/incidents.html'], function() {
                    let template = require('./app/medical/views/incidents/incidents.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'incidentsCtrl',
            controllerAs: 'incidentsCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/incidents/incidents.js');
                        $ocLazyLoad.load({
                            name: 'incidentsCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('firstAidForm', {
            url: '/first-aid-form',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/incidents/createFirstAidForm.html'], function() {
                    let template = require('./app/medical/views/incidents/createFirstAidForm.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'firstAidCtrl',
            controllerAs: 'firstAidCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/incidents/createFirstAidForm.js');
                        $ocLazyLoad.load({
                            name: 'firstAidCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('referralForm', {
            url: '/referral-form',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/incidents/createReferralForm.html'], function() {
                    let template = require('./app/medical/views/incidents/createReferralForm.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'referralCtrl',
            controllerAs: 'referralCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/incidents/createReferralForm.js');
                        $ocLazyLoad.load({
                            name: 'referralCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('vaccinationForm', {
            url: '/vaccination-form',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/incidents/createVaccinationForm.html'], function() {
                    let template = require('./app/medical/views/incidents/createVaccinationForm.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'vaccinationCtrl',
            controllerAs: 'vaccinationCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/incidents/createVaccinationForm.js');
                        $ocLazyLoad.load({
                            name: 'vaccinationCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('inventory', {
            url: '/inventory',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/inventory/inventory.html'], function() {
                    let template = require('./app/medical/views/inventory/inventory.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'inventoryCtrl',
            controllerAs: 'inventoryCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/inventory/inventory.js');
                        $ocLazyLoad.load({
                            name: 'inventoryCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('inventoryList', {
            url: '/inventory-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/inventory/inventoryList.html'], function() {
                    let template = require('./app/medical/views/inventory/inventoryList.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'inventoryListCtrl',
            controllerAs: 'inventoryListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/inventory/inventoryList.js');
                        $ocLazyLoad.load({
                            name: 'inventoryListCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('purchaseOrder', {
            url: '/purchase-order',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/inventory/purchaseOrder.html'], function() {
                    let template = require('./app/medical/views/inventory/purchaseOrder.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'purchaseOrderCtrl',
            controllerAs: 'purchaseOrderCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/inventory/purchaseOrder.js');
                        $ocLazyLoad.load({
                            name: 'purchaseOrderCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('purchaseList', {
            url: '/purchase-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/inventory/purchaseList.html'], function() {
                    let template = require('./app/medical/views/inventory/purchaseList.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'purchaseListCtrl',
            controllerAs: 'purchaseListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/inventory/purchaseList.js');
                        $ocLazyLoad.load({
                            name: 'purchaseListCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('stockList', {
            url: '/stock-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/inventory/stockDetails.html'], function() {
                    let template = require('./app/medical/views/inventory/stockDetails.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'stockDetailsCtrl',
            controllerAs: 'stockDetailsCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/inventory/stockDetails.js');
                        $ocLazyLoad.load({
                            name: 'stockDetailsCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('userProfile', {
            url: '/user-profile',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/userProfile.html'], function() {
                    let template = require('./app/medical/views/userProfile.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'userProfileCtrl',
            controllerAs: 'userProfileCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/userProfile.js');
                        $ocLazyLoad.load({
                            name: 'userProfileCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('userFilter', {
            url: '/user-filter',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/userFilter.html'], function() {
                    let template = require('./app/medical/views/userFilter.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'userFilterCtrl',
            controllerAs: 'userFilterCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/userFilter.js');
                        $ocLazyLoad.load({
                            name: 'userFilterCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('medicalProfile', {
            url: '/medical-profile',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/myMedicalProfile.html'], function() {
                    let template = require('./app/medical/views/myMedicalProfile.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'medicalProfileCtrl',
            controllerAs: 'medicalProfileCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/myMedicalProfile.js');
                        $ocLazyLoad.load({
                            name: 'medicalProfileCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createProgramme', {
            url: '/create-programme',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/medicalProgramme/createProgramme.html'], function() {
                    let template = require('./app/medical/views/medicalProgramme/createProgramme.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createProgrammeCtrl',
            controllerAs: 'createProgrammeCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/medicalProgramme/createProgramme.js');
                        $ocLazyLoad.load({
                            name: 'createProgrammeCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewProgramme', {
            url: '/view-programme',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/medicalProgramme/viewProgramme.html'], function() {
                    let template = require('./app/medical/views/medicalProgramme/viewProgramme.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewProgrammeCtrl',
            controllerAs: 'viewProgrammeCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/medicalProgramme/viewProgramme.js');
                        $ocLazyLoad.load({
                            name: 'viewProgrammeCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('programmeConsole', {
            url: '/programme-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/medical/views/medicalProgramme/programmeConsole.html'], function() {
                    let template = require('./app/medical/views/medicalProgramme/programmeConsole.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'programmeConsoleCtrl',
            controllerAs: 'programmeConsoleCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/medical/controllers/medicalProgramme/programmeConsole.js');
                        $ocLazyLoad.load({
                            name: 'programmeConsoleCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('myStudentsList', {
            url: '/my-students-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/my-students/views/list.html'], function() {
                    let template = require('./app/my-students/views/list.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'myStudentsList',
            controllerAs: 'myStudentsList',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/my-students/my-students-module.js');
                        $ocLazyLoad.load({
                            name: 'myStudentsList'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('Shuffle',{
            url:'/Shuffle',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/house_suffler/views/houseShuffler.html'],function(){
                    let template = require('./app/house_suffler/views/houseShuffler.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'houseShufflerController',
            controllerAs:'houseShufflerController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/house_suffler/house_shuffler_module.js');
                    $ocLazyLoad.load({
                        name:'houseShuffler'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('manageHouses',{
            url:'/manageHouses',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/manageHouses/views/manageHouses.html'],function(){
                    let template = require('./app/manageHouses/views/manageHouses.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'manageHousesController',
            controllerAs:'manageHousesController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/manageHouses/manageHousesModule.js');
                    $ocLazyLoad.load({
                        name:'manageHouses'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('lessonPlan',{
            url:'/lessonPlan',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/lessonPlan/views/lessonPlan.html'],function(){
                    let template = require('./app/lessonPlan/views/lessonPlan.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'lpController',
            controllerAs:'lpController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/lessonPlan/lessonPlanModule');
                    $ocLazyLoad.load({
                        name:'lessonPlan'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('editLesson',{
            url:'/lessonPlan/editLesson/:lesson_id',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/lessonPlan/views/editLesson.html'],function(){
                    let template = require('./app/lessonPlan/views/editLesson.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'editLpController',
            controllerAs:'editLpController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/lessonPlan/lessonPlanModule');
                    $ocLazyLoad.load({
                        name:'lessonPlan'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('copyLesson',{
            url:'/lessonPlan/copyLesson/:lesson_id',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/lessonPlan/views/copyLesson.html'],function(){
                    let template = require('./app/lessonPlan/views/copyLesson.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'editLpController',
            controllerAs:'editLpController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/lessonPlan/lessonPlanModule');
                    $ocLazyLoad.load({
                        name:'lessonPlan'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('viewLesson',{
            url:'/lessonPlan/viewLesson/:lesson_id/:view',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/lessonPlan/views/editLesson.html'],function(){
                    let template = require('./app/lessonPlan/views/editLesson.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'editLpController',
            controllerAs:'editLpController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/lessonPlan/lessonPlanModule');
                    $ocLazyLoad.load({
                        name:'lessonPlan'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('viewLessonPlan',{
            url:'/lessonPlan/viewLessonPlan/:lesson_id/:view',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/lessonPlan/views/viewLessonPlan.html'],function(){
                    let template = require('./app/lessonPlan/views/viewLessonPlan.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'editLpController',
            controllerAs:'editLpController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/lessonPlan/lessonPlanModule');
                    $ocLazyLoad.load({
                        name:'lessonPlan'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('addLesson',{
            url:'/lessonPlan/addLesson',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/addLesson/views/addLesson.html'],function(){
                    let template = require('./app/addLesson/views/addLesson.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'addLessonController',
            controllerAs:'addLessonController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/addLesson/addLessonModule');
                    $ocLazyLoad.load({
                        name:'addLesson'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('editHodLesson',{
            url:'/lessonPlan/editHodLesson/:lesson_id',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/addLesson/views/editHodLesson.html'],function(){
                    let template = require('./app/addLesson/views/editHodLesson.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'editHodLessonController',
            controllerAs:'editHodLessonController',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/addLesson/addLessonModule');
                    $ocLazyLoad.load({
                        name:'addLesson'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('addTeacherLesson',{
            url:'/lessonPlan/addTeacherLesson',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/addLesson/views/addTeacherLesson.html'],function(){
                    let template = require('./app/addLesson/views/addTeacherLesson.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'addTeacherLessonCrtl',
            controllerAs:'addTeacherLessonCrtl',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/addLesson/addLessonModule');
                    $ocLazyLoad.load({
                        name:'addLesson'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('editTeacherLesson',{
            url:'/lessonPlan/editTeacherLesson/:lesson_id',
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/addLesson/views/addTeacherLesson.html'],function(){
                    let template = require('./app/addLesson/views/addTeacherLesson.html');
                    deffered.resolve(template);
                });
                return deffered.promise
            }],
            controller:'addTeacherLessonCrtl',
            controllerAs:'addTeacherLessonCrtl',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deferred = $q.defer();
                  require.ensure([],function(){
                    let module = require('./app/addLesson/addLessonModule');
                    $ocLazyLoad.load({
                        name:'addLesson'
                    });
                    deferred.resolve(module)
                  });
                  return deferred.promise
                }]
            }
        })
        .state('examTmConsole', {
            url: '/exam-scheduler-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/exam-tm-console/views/console.html'], function() {
                    let template = require('./app/exam-tm-console/views/console.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'examTmConsole',
            controllerAs: 'examTmConsole',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/exam-tm-console/exam-tm-consoleModule.js');
                        $ocLazyLoad.load({
                            name: 'examTmConsole'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('examTmCreate', {
            url: '/exam-scheduler-form/:scheduler_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/exam-tm-console/views/exam-create.html'], function() {
                    let template = require('./app/exam-tm-console/views/exam-create.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'examTmCreate',
            controllerAs: 'examTmCreate',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/exam-tm-console/exam-tm-createModule.js');
                        $ocLazyLoad.load({
                            name: 'examTmCreate'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('quizApiMain', {
            url: '/user/quiz/main/:category',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/quiz-component/views/quiz.html'], function() {
                    let template = require('./app/quiz-component/views/quiz.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'quizApiMain',
            controllerAs: 'quizApiMain',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/quiz-component/quizModule.js');
                        $ocLazyLoad.load({
                            name: 'quizApiMain'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('quizPointSummary', {
            url: '/user/quiz/summary',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/quiz-component/views/summary.html'], function() {
                    let template = require('./app/quiz-component/views/summary.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'quizPointSummary',
            controllerAs: 'quizPointSummary',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/quiz-component/quizSummaryModule.js');
                        $ocLazyLoad.load({
                            name: 'quizPointSummary'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('quizDetailMain', {
            url: '/user/quiz/detail/:quiz_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/quiz-component/views/detail.html'], function() {
                    let template = require('./app/quiz-component/views/detail.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'quizDetailMain',
            controllerAs: 'quizDetailMain',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/quiz-component/quizDetailModule.js');
                        $ocLazyLoad.load({
                            name: 'quizDetailMain'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('lastquizQuizDetail', {
            url: '/user/quiz/last/:quiz_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/quiz-component/views/lastquiz.html'], function() {
                    let template = require('./app/quiz-component/views/lastquiz.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'lastquizQuizDetail',
            controllerAs: 'lastquizQuizDetail',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/quiz-component/lastquizSummaryModule.js');
                        $ocLazyLoad.load({
                            name: 'lastquizQuizDetail'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('gmail', {
            url: '/gmail',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/gmail/views/gmail.html'], function() {
                    let template = require('./app/gmail/views/gmail.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'gmailCtrl',
            controllerAs: 'gmailCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/gmail/gmailModule.js');
                        $ocLazyLoad.load({
                            name: 'GmailModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('batchChange', {
            url: '/batch_change',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/batch-change/views/batchChange.html'], function() {
                    let template = require('./app/batch-change/views/batchChange.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'batchChangeCtrl',
            controllerAs: 'batchChangeCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/batch-change/batchChangeModule.js');
                        $ocLazyLoad.load({
                            name: 'BatchChangeModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('markEntrySheet', {
            url: '/mark_entry_sheet',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry_sheet/views/markEntrySheet.html'], function() {
                    let template = require('./app/mark_entry_sheet/views/markEntrySheet.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'MarkEntryCtrl',
            controllerAs: 'MarkEntryCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry_sheet/markEntryModule.js');
                        $ocLazyLoad.load({
                            name: 'MarkEntry'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('messageMainModule', {
            url: '/messages-main',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/message-module/messageMainModule.js'], function() {
                    let template = require('./app/message-module/views/message-main.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'messageMainModuleController',
            controllerAs: 'messageMainModuleController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/message-module/messageMainModule.js');
                        $ocLazyLoad.load({
                            name: 'messageMainModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('messageHistory', {
            url: '/messages-history',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/message-module/messageHisModule.js'], function() {
                    let template = require('./app/message-module/views/message-history.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'messageHisModuleController',
            controllerAs: 'messageHisModuleController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/message-module/messageHisModule.js');
                        $ocLazyLoad.load({
                            name: 'messageHisModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('activitypersstudentCtrl', {
            url: '/student/one-activity/:qp_id/:student_id/:page',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/assessment-reports/views/activityperstudent.html'], function() {
                    let template = require('./app/assessment-reports/views/activityperstudent.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'activitypersstudentCtrl',
            controllerAs: 'activitypersstudentCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/assessment-reports/activityperstudentModule.js');
                        $ocLazyLoad.load({
                            name: 'activitypersstudentCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('ActivitiesComparisonStudentWiseCtrl', {
            url: '/activity-comparison/student',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/assessment-reports/activityComparisonStudentwiseModule.js'], function() {
                    let template = require('./app/assessment-reports/views/comparison-student.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ActivitiesComparisonStudentWiseCtrl',
            controllerAs: 'activitiesComparisonStudentWiseCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/assessment-reports/activityComparisonStudentwiseModule.js');
                        $ocLazyLoad.load({
                            name: 'ActivitiesComparisonStudentWiseCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('ActivitiesComparisonBatchWiseCtrl', {
            url: '/activity-comparison/batch',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/assessment-reports/activityComparisonBatchwiseModule.js'], function() {
                    let template = require('./app/assessment-reports/views/comparison-batch.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ActivitiesComparisonBatchWiseCtrl',
            controllerAs: 'activitiesComparisonBatchWiseCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/assessment-reports/activityComparisonBatchwiseModule.js');
                        $ocLazyLoad.load({
                            name: 'ActivitiesComparisonBatchWiseCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('reportsScoresCtrl', {
            url: '/activity-report/scores/:qp_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/assessment-reports/reportsScoresModule.js'], function() {
                    let template = require('./app/assessment-reports/views/view-scores.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'reportsScoresCtrl',
            controllerAs: 'reportsScoresCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/assessment-reports/reportsScoresModule.js');
                        $ocLazyLoad.load({
                            name: 'reportsScoresCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('feedueList', {
            url: '/feedue-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/feedueList/views/feedueListView.html'], function() {
                    let template = require('./app/feedueList/views/feedueListView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'feedueList',
            controllerAs: 'feedueList',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/feedueList/feedueListModule.js');
                        $ocLazyLoad.load({
                            name: 'FeedueListModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('eduConnect', {
            url: '/edu-connect',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/edu-connect/edu-connect-module.js'], function() {
                    let template = require('./app/edu-connect/views/list.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'eduConnect',
            controllerAs: 'eduConnect',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/edu-connect/edu-connect-module.js');
                        $ocLazyLoad.load({
                            name: 'eduConnect'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('eduConnectMeet', {
            url: '/edu-connect-meet',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/edu-connect/edu-connect-module.js'], function() {
                    let template = require('./app/edu-connect/views/meet.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'eduConnect',
            controllerAs: 'eduConnect',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/edu-connect/edu-connect-module.js');
                        $ocLazyLoad.load({
                            name: 'eduConnect'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('eduConnectMeetCreate', {
            url: '/create-meet',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/edu-connect/edu-connect-module.js'], function() {
                    let template = require('./app/edu-connect/views/meet_create.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'eduConnect',
            controllerAs: 'eduConnect',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/edu-connect/edu-connect-module.js');
                        $ocLazyLoad.load({
                            name: 'eduConnect'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('eduConnectMeetList', {
            url: '/meet-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/edu-connect/edu-connect-module.js'], function() {
                    let template = require('./app/edu-connect/views/meet_list.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'eduConnect',
            controllerAs: 'eduConnect',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/edu-connect/edu-connect-module.js');
                        $ocLazyLoad.load({
                            name: 'eduConnect'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('activityApprovalsList', {
            url: '/activity-approvals-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/activity_approvals/activity_approvalsModule.js'], function() {
                    let template = require('./app/activity_approvals/views/activity_approvals_list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ActivityApprovalsList',
            controllerAs: 'activityApprovalsListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/activity_approvals/activity_approvalsModule.js');
                        $ocLazyLoad.load({
                            name: 'ActivityApprovalsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('activityReportViaLinkCtrl', {
            url: '/one-student/one-activity/:qp_id/:student_id/:page/:teacher_id/:parent_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/assessment-reports/views/activityReportViaLink.html'], function() {
                    let template = require('./app/assessment-reports/views/activityReportViaLink.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'activityReportViaLinkCtrl',
            controllerAs: 'activityReportViaLinkCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/assessment-reports/activityReportViaLinkCtrl.js');
                        $ocLazyLoad.load({
                            name: 'activityReportViaLinkCtrl'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('feeDueMessageConsole', {
            url: '/fee-due-msg-console',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/fee_due_messages/views/fee_due_messages.html'], function() {
                    let template = require('./app/fee_due_messages/views/fee_due_messages.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'FeeDueMessageConsole',
            controllerAs: 'feeDueMessageConsole',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/fee_due_messages/fee_due_messagesModule.js');
                        $ocLazyLoad.load({
                            name: 'FeeDueMessageConsole'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('qpToOtherSchoolsController', {
            url: '/assign-qp-other-schools',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/qp_to_other_school/views/qpToOtherSchools.html'], function() {
                    let template = require('./app/qp_to_other_school/views/qpToOtherSchools.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'qpToOtherSchoolsController',
            controllerAs: 'qpToOtherSchoolsController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/qp_to_other_school/qpToOtherSchoolsModule.js');
                        $ocLazyLoad.load({
                            name: 'qpToOtherSchoolsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('qpPreviewController', {
            url: '/qp-preview-page/:qpId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/qp_to_other_school/views/qpPreview.html'], function() {
                    let template = require('./app/qp_to_other_school/views/qpPreview.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'qpPreviewController',
            controllerAs: 'qpPreviewController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/qp_to_other_school/qpToOtherSchoolsModule.js');
                        $ocLazyLoad.load({
                            name: 'qpToOtherSchoolsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentEndorsementController', {
            url: '/student_endorsement/ct' ,
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/teacherStudentEndorsement/views/studentEndorsement.html'], function() {
                    let template = require('./app/teacherStudentEndorsement/views/studentEndorsement.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentEndorsementByCTController',
            controllerAs: 'usermgtStudentCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/teacherStudentEndorsement/studentEndorsementModule.js');
                        $ocLazyLoad.load({
                            name: 'teacherStudentEndorsement'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('endorsementByHosController', {
            url: '/teacher-endorse/by/hos',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/endorsement-by-hos/views/endorsementByHos.html'], function() {
                    let template = require('./app/endorsement-by-hos/views/endorsementByHos.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'endorsementByHosController',
            controllerAs: 'userManagementDirectiveHOS',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/endorsement-by-hos/endorsementByHosModule.js');
                        $ocLazyLoad.load({
                            name: 'endorsementByHosModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewActivityAttendeesSheet', {
            url: '/view/activity-answer-sheet',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/view-activity-answers/views/view_answer_select.html'], function() {
                    let template = require('./app/view-activity-answers/views/view_answer_select.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'viewActivityAttendeesSheetCtrl',
            controllerAs: 'viewActivityAttendeesSheetCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/view-activity-answers/viewActivityAnswerSheetModule.js');
                        $ocLazyLoad.load({
                            name: 'viewActivityAttendeesSheetModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('loginViaLinkController', {
            url: '/one-student/shared-activity/:qp_id/:student_id/:page/:teacher_id/:parent_username/:parent_id/:school_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/login-via-link/views/loginViaLink.html'], function() {
                    let template = require('./app/login-via-link/views/loginViaLink.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'loginViaLinkController',
            controllerAs: 'loginViaLinkController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/login-via-link/loginViaLinkModule.js');
                        $ocLazyLoad.load({
                            name: 'loginViaLinkController'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('answersheetPreview', {
            url: '/student-answer-sheet/:qpId/:studentId',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/answersheet-preview.html'], function() {
                    let template = require('./app/traditionalActivity/views/answersheet-preview.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'answersheetPreview',
            controllerAs: 'answersheetPreview',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/traditionalActivity/controllers/answersheetPreview.js');
                        $ocLazyLoad.load({
                            name: 'answersheetPreview'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('CatfourMainController', {
            url: '/cat-4-main',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/catfour-main.html'], function() {
                    let template = require('./app/cat-four/views/catfour-main.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'CatfourMainController',
            controllerAs: 'CatfourMainController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/catfourMainModule.js');
                        $ocLazyLoad.load({
                            name: 'catfourMainModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('ClassteacherCrudController', {
            url: '/cat-4-teacher-entry',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/classteacher-crud.html'], function() {
                    let template = require('./app/cat-four/views/classteacher-crud.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ClassteacherCrudController',
            controllerAs: 'ClassteacherCrudController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/classteacherCrudModule.js');
                        $ocLazyLoad.load({
                            name: 'ClassteacherCrudModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('entryByClassTeacherController', {
            url: '/class-story',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/ClassStory.html'], function() {
                    let template = require('./app/cat-four/views/ClassStory.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'entryByClassTeacherController',
            controllerAs: 'entryByClassTeacherController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/ClassStoryModule.js');
                        $ocLazyLoad.load({
                            name: 'classStoryModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentclassStoryController', {
            url: '/student-class-story/:student_id/:report_console_id/:academic_year',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/studentclassstory.html'], function() {
                    let template = require('./app/cat-four/views/studentclassstory.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'studentclassStoryController',
            controllerAs: 'studentclassStoryController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/studentclassStoryModule.js');
                        $ocLazyLoad.load({
                            name: 'studentclassStoryModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('StudentScoreViewController', {
            url: '/asset-score/student-view/:student_id/:report_console_id/:subject_id/:selected_year',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/studentScoreViewController.html'], function() {
                    let template = require('./app/cat-four/views/studentScoreViewController.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'StudentScoreViewController',
            controllerAs: 'StudentScoreViewController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/studentScoreViewModule.js');
                        $ocLazyLoad.load({
                            name: 'studentScoreViewModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('ClassStoryViewController', {
            url: '/view/class/story/:session_id/:curriculum_id/:class_id/:batch_id/:academic/:is_class_teacher/:is_authority/:selected_year',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/ClassStoryView.html'], function() {
                    let template = require('./app/cat-four/views/ClassStoryView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ClassStoryViewController',
            controllerAs: 'ClassStoryViewController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/ClassStoryViewModule.js');
                        $ocLazyLoad.load({
                            name: 'ClassStoryViewModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('ClassStudentsController', {
            url: '/view/class/students/:session_id/:curriculum_id/:class_id/:batch_id/:academic/:is_class_teacher',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/class_students/views/class-students.html'], function() {
                    let template = require('./app/class_students/views/class-students.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ClassStudentsController',
            controllerAs: 'ClassStudentsController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/class_students/classStudentsModule.js');
                        $ocLazyLoad.load({
                            name: 'ClassStudentsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('ProcturedDocumentController', {
            url: '/view/activity/students/procturing',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/traditionalActivity/views/procturedDocument.html'], function() {
                    let template = require('./app/traditionalActivity/views/procturedDocument.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ProcturedDocumentController',
            controllerAs: 'ProcturedDocumentController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/traditionalActivity/controllers/procturedDocumentsController.js');
                        $ocLazyLoad.load({
                            name: 'ProcturedDocumentController'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('hodHosClassStory', {
            url: '/view/class/story',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/hod-hod-class-story.html'], function() {
                    let template = require('./app/cat-four/views/hod-hod-class-story.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'hodHosClassStory',
            controllerAs: 'hodHosClassStory',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/hodHosClassStoryModule.js');
                        $ocLazyLoad.load({
                            name: 'hodHosClassStory'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classStoryRedefinedController', {
            url: '/class/story/eoy',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/classStoryRedefined.html'], function() {
                    let template = require('./app/cat-four/views/classStoryRedefined.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classStoryRedefinedController',
            controllerAs: 'classStoryRedefinedController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/classStoryRedefinedModule.js');
                        $ocLazyLoad.load({
                            name: 'classStoryRedefinedModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classStoryForMngrCtrl', {
            url: '/class/story/eoy/mngr',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/classStoryForMngrCtrl.html'], function() {
                    let template = require('./app/cat-four/views/classStoryForMngrCtrl.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classStoryForMngrCtrl',
            controllerAs: 'classStoryForMngrCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/classStoryForMngrModule.js');
                        $ocLazyLoad.load({
                            name: 'classStoryForMngrModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classStoryPreYearUpdatesCtrl', {
            url: '/class/story/eoy/pre/year',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/classStoryPreYearUpdates.html'], function() {
                    let template = require('./app/cat-four/views/classStoryPreYearUpdates.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classStoryPreYearUpdatesCtrl',
            controllerAs: 'classStoryPreYearUpdatesCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/classStoryPreYearUpdatesModule.js');
                        $ocLazyLoad.load({
                            name: 'classStoryPreYearUpdatesModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('attainmentReportAsset', {
            url: '/attainment-report/asset',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/attainmentReportAsset.html'], function() {
                    let template = require('./app/cat-four/views/attainmentReportAsset.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'attainmentReportAsset',
            controllerAs: 'attainmentReportAsset',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/attainmentReportAssetModule.js');
                        $ocLazyLoad.load({
                            name: 'AttainmentReportAssetModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('attainmentReportInternalscore', {
            url: '/attainment-report/internal-score',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/attainmentReportInternalscore.html'], function() {
                    let template = require('./app/cat-four/views/attainmentReportInternalscore.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'attainmentReportInternalscore',
            controllerAs: 'attainmentReportInternalscore',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/attainmentReportInternalscoreModule.js');
                        $ocLazyLoad.load({
                            name: 'AttainmentReportInternalscoreModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('PasswordResetCtrl', {
            url: '/password-reset',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/utilities/passwordreset/view/passwordreset.html'], function() {
                    let template = require('./app/utilities/passwordreset/view/passwordreset.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'PasswordResetCtrl',
            controllerAs: 'PasswordResetCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/utilities/passwordreset/passwordresetModule.js');
                        $ocLazyLoad.load({
                            name: 'PasswordresetModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('BlockUsersCtrl', {
            url: '/utilities/block/users',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/utilities/block-users/views/blockUser.html'], function() {
                    let template = require('./app/utilities/block-users/views/blockUser.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'BlockUsersCtrl',
            controllerAs: 'BlockUsersCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/utilities/block-users/blockUsersModule.js');
                        $ocLazyLoad.load({
                            name: 'BlockUsersModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('policyManagement', {
            url: '/school/policy/list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/school_policy/views/list.html'], function() {
                    let template = require('./app/school_policy/views/list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'policyManagement',
            controllerAs: 'policyManagement',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/school_policy/schoolPolicyModule.js');
                        $ocLazyLoad.load({
                            name: 'schoolPolicyModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('schoolPolicyAddConttroller', {
            url: '/school/policy/add/:policy_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/school_policy/views/add.html'], function() {
                    let template = require('./app/school_policy/views/add.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'schoolPolicyAddController',
            controllerAs: 'schoolPolicyAddController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/school_policy/schoolPolicyModule.js');
                        $ocLazyLoad.load({
                            name: 'schoolPolicyModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('schoolPolicyViewController', {
            url: '/school/policy/view/:policy_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/school_policy/views/view.html'], function() {
                    let template = require('./app/school_policy/views/view.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'schoolPolicyViewController',
            controllerAs: 'schoolPolicyViewController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/school_policy/schoolPolicyModule.js');
                        $ocLazyLoad.load({
                            name: 'schoolPolicyModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('multipleReportsSelectionCtrl', {
            url: '/multiple-report-selection',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/multiple-reportcards/views/multipleReportCardSelection.html'], function() {
                    let template = require('./app/multiple-reportcards/views/multipleReportCardSelection.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'multipleReportsSelectionCtrl',
            controllerAs: 'multipleReportsSelectionCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/multiple-reportcards/multipleReportCardModule.js');
                        $ocLazyLoad.load({
                            name: 'multipleReportCardModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('khdaMainModule', {
            url: '/khda-main',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/khda/khdaModule.js'], function() {
                    let template = require('./app/khda/views/main.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'khdaMainModule',
            controllerAs: 'khdaMainModule',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/khda/khdaModule.js');
                        $ocLazyLoad.load({
                            name: 'khdaMainModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('examReminder', {
            url: '/exam-reminder-list',
            templateProvider: ['$q', function ($q) {
                let deferred = $q.defer();
                require.ensure(['./app/examCalendar/examCalendarModule.js'], function () {
                    let template = require('./app/examCalendar/views/list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'examCalendarListModule',
            controllerAs: 'examCalendarListModule',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('./app/examCalendar/examCalendarModule.js');
                        $ocLazyLoad.load({
                            name: 'examCalendarMainModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('examCalendarMainModule', {
            url: '/exam-reminder',
            templateProvider: ['$q', function ($q) {
                let deferred = $q.defer();
                require.ensure(['./app/examCalendar/examCalendarModule.js'], function () {
                    let template = require('./app/examCalendar/views/main.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'examCalendarMainModule',
            controllerAs: 'examCalendarMainModule',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('./app/examCalendar/examCalendarModule.js');
                        $ocLazyLoad.load({
                            name: 'examCalendarMainModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })

        .state('phaseModule', {
            url: '/khda-phase',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/khda/phaseModule.js'], function() {
                    let template = require('./app/khda/views/phase.html');
                    deferred.resolve(template);
                });

                return deferred.promise;
            }],
            controller: 'phaseModule',
            controllerAs: 'phaseModule',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/khda/phaseModule.js');
                        $ocLazyLoad.load({
                            name: 'phaseModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('learningevaluationLearningWalk', {
            url: '/learning/walk',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/learning_walk/views/learning_walkHtml.html'], function() {
                    let template = require('./app/learning_walk/views/learning_walkHtml.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'learningwalkController',
            controllerAs: 'learningwalkController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/learning_walk/learingModule.js');
                        $ocLazyLoad.load({
                            name: 'learningModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('learningevaluationLearningObservation', {
            url: '/lession/observation',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/lession_observation/views/lessionobservationhtml.html'], function() {
                    let template = require('./app/lession_observation/views/lessionobservationhtml.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'lessionController',
            controllerAs: 'lessionController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/lession_observation/observationModule.js');
                        $ocLazyLoad.load({
                            name: 'lessionModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('lessonList', {
            url: '/lession/observation/list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/lession_observation/views/lessonObservationList.html'], function() {
                    let template = require('./app/lession_observation/views/lessonObservationList.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'lessionControllerList',
            controllerAs: 'lessionControllerList',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/lession_observation/observationModule.js');
                        $ocLazyLoad.load({
                            name: 'lessionModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('lessonView', {
            url: '/lession/observation/view/:_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/lession_observation/views/lessonObservationView.html'], function() {
                    let template = require('./app/lession_observation/views/lessonObservationView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'lessionControllerView',
            controllerAs: 'lessionControllerView',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/lession_observation/observationModule.js');
                        $ocLazyLoad.load({
                            name: 'lessionModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })

        .state('learningList', {
            url: '/learning/walk/list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/learning_walk/views/learningWalkList.html'], function() {
                    let template = require('./app/learning_walk/views/learningWalkList.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'learningControllerList',
            controllerAs: 'learningControllerList',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/learning_walk/learingModule.js');
                        $ocLazyLoad.load({
                            name: 'learningModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('learningView', {
            url: '/learning/walk/view/:_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/learning_walk/views/learningWalkView.html'], function() {
                    let template = require('./app/learning_walk/views/learningWalkView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'learningControllerView',
            controllerAs: 'learningControllerView',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/learning_walk/learingModule.js');
                        $ocLazyLoad.load({
                            name: 'learningModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('finalConsolidatedController', {
            url: '/final/Consolidated/sheets',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/consolidated-sheets/views/finalConsolidatedSheets.html'], function() {
                    let template = require('./app/consolidated-sheets/views/finalConsolidatedSheets.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'finalConsolidatedController',
            controllerAs: 'finalConsolidatedController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/consolidated-sheets/consolidatedSheetsModule.js');
                        $ocLazyLoad.load({
                            name: 'consolidatedSheetsModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('BenchmarkUtilitiesMain', {
            url: '/benchmark-utilities',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/benchmark-utilities/views/benchmarkUtilitiesMain.html'], function() {
                    let template = require('./app/benchmark-utilities/views/benchmarkUtilitiesMain.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'benchmarkUtilitiesMainController',
            controllerAs: 'benchmarkUtilitiesMainController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/benchmark-utilities/BenchmarkUtilitiesMainModule.js');
                        $ocLazyLoad.load({
                            name: 'benchmarkUtilitiesMainModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('BenchmarkBatchChangeCtrl', {
            url: '/benchmark-utilities-batchchange',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/benchmark-utilities/views/benchmarkBatchChange.html'], function() {
                    let template = require('./app/benchmark-utilities/views/benchmarkBatchChange.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'benchmarkBatchChangeCtrl',
            controllerAs: 'benchmarkBatchChangeCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/benchmark-utilities/BenchmarkUtilitiesMainModule.js');
                        $ocLazyLoad.load({
                            name: 'benchmarkUtilitiesMainModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('benchmarkNewStudentCtrl', {
            url: '/benchmark-utilities-new-students',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/benchmark-utilities/views/benchmarkNewStudents.html'], function() {
                    let template = require('./app/benchmark-utilities/views/benchmarkNewStudents.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'benchmarkNewStudentCtrl',
            controllerAs: 'benchmarkNewStudentCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/benchmark-utilities/BenchmarkUtilitiesMainModule.js');
                        $ocLazyLoad.load({
                            name: 'benchmarkUtilitiesMainModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('benchmarkStatusChangeCtrl', {
            url: '/benchmark-utilities-students-status',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/benchmark-utilities/views/benchmarkStatusChange.html'], function() {
                    let template = require('./app/benchmark-utilities/views/benchmarkStatusChange.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'benchmarkStatusChangeCtrl',
            controllerAs: 'benchmarkStatusChangeCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/benchmark-utilities/BenchmarkUtilitiesMainModule.js');
                        $ocLazyLoad.load({
                            name: 'benchmarkUtilitiesMainModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('benchmarkNewAcdStudentCtrl', {
            url: '/benchmark-utilities-new-acd-students',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/benchmark-utilities/views/benchmarkNewAcdStudents.html'], function() {
                    let template = require('./app/benchmark-utilities/views/benchmarkNewAcdStudents.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'benchmarkNewAcdStudentCtrl',
            controllerAs: 'benchmarkNewAcdStudentCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/benchmark-utilities/BenchmarkUtilitiesMainModule.js');
                        $ocLazyLoad.load({
                            name: 'benchmarkUtilitiesMainModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('ClassparentsController', {
            url: '/view/class/parents/:session_id/:curriculum_id/:class_id/:batch_id/:academic/:is_class_teacher',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/class_parents/views/class-parents.html'], function() {
                    let template = require('./app/class_parents/views/class-parents.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ClassparentsController',
            controllerAs: 'ClassparentsController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/class_parents/classparentsModule.js');
                        $ocLazyLoad.load({
                            name: 'ClassparentsModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('evaluationSubmissions',{
            url:'/teacherevaluation',
            templateProvider:['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/teacher_Evaluation/views/teacher_evaluation.html'], function() {
                    let template = require('./app/teacher_Evaluation/views/teacher_evaluation.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'loSubmissionsCtrl',
            controllerAs: 'loSubmissionsCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/teacher_Evaluation/teacher_evaluation_mainModule.js');
                        $ocLazyLoad.load({
                            name: 'teacherEvaluationMainModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('analysisCtrl',{
            url:'/evaluation/analysis/:teacher_id/:eval_type/:year',
            templateProvider:['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/teacher_Evaluation/views/analysis.html'], function() {
                    let template = require('./app/teacher_Evaluation/views/analysis.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'analysisCtrl',
            controllerAs: 'analysisCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/teacher_Evaluation/teacher_evaluation_mainModule.js');
                        $ocLazyLoad.load({
                            name: 'teacherEvaluationMainModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('AdmitcardController', {
            // url: '/view/admitcard/students/:session_id/:curriculum_id/:class_id/:batch_id/:academic/:is_class_teacher',
            url: '/view/admitcard/students',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/admit_card/views/admit_card_student.html'], function() {
                    let template = require('./app/admit_card/views/admit_card_student.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'AdmitcardController',
            controllerAs: 'AdmitcardController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/admit_card/AdmitcardModule.js');
                        $ocLazyLoad.load({
                            name: 'AdmitcardModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('AdmitcardList', {
            url: '/view/admitcard/list/:admitcardid/:session_id/:curriculum_id/:class_id/:batch_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/admit_card/views/admit_card.html'], function() {
                    let template = require('./app/admit_card/views/admit_card_list.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'AdmitcardController',
            controllerAs: 'AdmitcardController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/admit_card/AdmitcardModule.js');
                        $ocLazyLoad.load({
                            name: 'AdmitcardModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('GreetingsController', {
            url: '/view/Greetings/students/:session_id/:curriculum_id/:class_id/:batch_id/:academic',
            // url: '/view/Greetings/students',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/greetings/views/greetings.html'], function() {
                    let template = require('./app/greetings/views/greetings.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'GreetingsController',
            controllerAs: 'GreetingsController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/greetings/GreetingsModule.js');
                        $ocLazyLoad.load({
                            name: 'GreetingsModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('greetingsView', {
            url: '/greetings_list',
            // url: '/view/Greetings/students',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/greetings/views/greetings-students.html'], function() {
                    let template = require('./app/greetings/views/greetings-students.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'GreetingsController',
            controllerAs: 'GreetingsController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/greetings/GreetingsModule.js');
                        $ocLazyLoad.load({
                            name: 'GreetingsModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('documentController', {
            url: '/ext/assessment/documents',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/documents/views/document.html'], function() {
                    let template = require('./app/documents/views/document.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'documentController',
            controllerAs: 'documentController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/documents/documentsModule.js');
                        $ocLazyLoad.load({
                            name: 'documentModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('khdaAttendanceController', {
            url: '/khda/attendance',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/khdaAtt/views/khdaAtt.html'], function() {
                    let template = require('./app/khdaAtt/views/khdaAtt.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'khdaAttendanceController',
            controllerAs: 'khdaAttendanceController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/khdaAtt/khdaAttModule.js');
                        $ocLazyLoad.load({
                            name: 'khdaAttModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })

        .state('khdaReportController', {
            url: '/khda/report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/khda-reports/views/khdareport.html'], function() {
                    let template = require('./app/khda-reports/views/khdareport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'khdaReportController',
            controllerAs: 'khdaReportController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/khda-reports/khdareportModule.js');
                        $ocLazyLoad.load({
                            name: 'khdareportModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('phaseWiseAtt', {
            url: '/phasewise-attendence-report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/dashboard_reports/views/phasewiseDailyAttendance.html'], function() {
                    let template = require('./app/dashboard_reports/views/phasewiseDailyAttendance.html');

                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'phaseWiseAtt',
            controllerAs: 'phaseWiseAtt',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {

                        let module = require('./app/dashboard_reports/dashBoardReportModule.js');
                        $ocLazyLoad.load({
                            name: 'DashboardReport'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('studentInfoController', {
            url: '/student-information/:student_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/student_info/views/studentinfo.html'], function() {
                    let template = require('./app/student_info/views/studentinfo.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'StudentInfoController',
            controllerAs: 'studentInfoController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/student_info/studentInfoModule.js');
                        $ocLazyLoad.load({
                            name: 'studentInfoMainModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })

        .state('syllabus', {
            url: '/syllabus-management',
            views: {
                '@': {
                    templateProvider: ['$q', function($q) {
                        let deferred = $q.defer();
                        require.ensure(['./app/syllabusManagement/views/syllabus.html'], function() {
                            let template = require('./app/syllabusManagement/views/syllabus.html');
                            deferred.resolve(template);
                        });
                        return deferred.promise;
                    }],
                    controller: "syllabusCtrl",
                    controllerAs: 'syllabus',
                }
            },
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/syllabusManagement/syllabusModule.js');
                        $ocLazyLoad.load({
                            name: 'syllabusModule'
                        });
                        deferred.resolve(module);
                    });

                    return deferred.promise;
                }]
            }
        })
        .state('aflReportListCtrl', {
            url: '/afl/list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/afl/views/aflreportList.html'], function() {
                    let template = require('./app/afl/views/aflreportList.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'aflReportListCtrl',
            controllerAs: 'aflReportListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/afl/aflReportModule.js');
                        $ocLazyLoad.load({
                            name: 'aflreportModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('AflViewMainCtrl', {
            url: '/afl/class/:qp_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/afl/views/aflClass.html'], function() {
                    let template = require('./app/afl/views/aflClass.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'AflViewMainCtrl',
            controllerAs: 'AflViewMainCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/afl/aflViewModule.js');
                        $ocLazyLoad.load({
                            name: 'aflViewMainComponent',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('aflStudentCtrl', {
            url: '/afl/student/:student_id/:qp_id/:page',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/afl/views/aflStudent.html'], function() {
                    let template = require('./app/afl/views/aflStudent.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'aflStudentCtrl',
            controllerAs: 'aflStudentCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/afl/aflViewModule.js');
                        $ocLazyLoad.load({
                            name: 'aflViewMainComponent',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('sodStudentsReports', {
            url: '/sod/report',
            templateProvider: ['$q', function($q) {
            let deferred = $q.defer();
            require.ensure(['./app/sod_report/views/sodList.html'], function() {
            let template = require('./app/sod_report/views/sodList.html');
            deferred.resolve(template);
            });
            return deferred.promise;
            }],
           controller: 'sodReportListCtrl',
            controllerAs: 'sodReportListCtrl',
            resolve: {
           foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
           let deferred = $q.defer();
            require.ensure([], function() {
            let module = require('./app/sod_report/sodModule.js');
            $ocLazyLoad.load({
            name: 'sodModule',

            });
            deferred.resolve(module);
            });
            return deferred.promise;
            }]
            }
           })

           .state('arabiclevelreport', {
            url: '/arabic/report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/arabic_report/views/arabiclist.html'], function() {
                    let template = require('./app/arabic_report/views/arabiclist.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'arabicReportListCtrl',
            controllerAs: 'arabicReportListCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/arabic_report/arabicModule.js');
                        $ocLazyLoad.load({
                            name: 'arabicModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('gridView', {
            url: '/learnngTracker/view/:ref_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/learningOutcomeTracker/views/lrning_otcme_tracker.html'], function() {
                    let template = require('./app/learningOutcomeTracker/views/lrning_otcme_tracker.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'learningTrackerCrctl',
            controllerAs: 'learningTrackerCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/learningOutcomeTracker/lrning_otcme_tracker_module.js');
                        $ocLazyLoad.load({
                            name: 'learningTracker',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('learningOutcomeTracker', {
            url: '/learningTracker',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/learningOutcomeTracker/views/gridView.html'], function() {
                    let template = require('./app/learningOutcomeTracker/views/gridView.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'gridViewCrctl',
            controllerAs: 'gridViewCrctl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/learningOutcomeTracker/lrning_otcme_tracker_module.js');
                        $ocLazyLoad.load({
                            name: 'learningTracker',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('prevReportEditCtrl', {
            url: '/prev-report-edit/:publish',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/prevReportEdit/views/prevReportEdit.html'], function() {
                    let template = require('./app/report_cards/prevReportEdit/views/prevReportEdit.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'prevReportEditCtrl',
            controllerAs: 'prevReportEditCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/prevReportEdit/prevReportEditModule.js');
                        $ocLazyLoad.load({
                            name: 'prevReportEditModule',

                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        }).state('reportCardPendingListing', {
            url: '/report-card-pending-list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/pending_report _cards/views/pending_report_cards.html'], function() {
                    let template = require('./app/report_cards/pending_report _cards/views/pending_report_cards.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ReportCardPendingListingCtrl',
            controllerAs: 'ReportCardPendingListingCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/pending_report _cards/ReportCardPendingListsModule.js');
                        $ocLazyLoad.load({
                            name: 'ReportCardPendingListsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        }).state('reportCardPendingListingTeacher', {
            url: '/report-card-pending-list-teacher/:class_id/:class_name',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/report_cards/pending_report _cards/views/pending_report_cards_teacher.html'], function() {
                    let template = require('./app/report_cards/pending_report _cards/views/pending_report_cards_teacher.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'ReportCardPendingTeacherListingCtrl',
            controllerAs: 'ReportCardPendingTeacherListingCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/report_cards/pending_report _cards/teacherReportcardModule.js');
                        $ocLazyLoad.load({
                            name: 'ReportCardPendingTeacherListsModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        }).state('reportCardPendingListingTable', {
            url: '/report-card-pending-list-table',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/dashboard/views/pending_report_table.html'], function() {
                    let template = require('./app/dashboard/views/pending_report_table.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'DashBoardController',
            controllerAs: 'test',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/dashboard/dashboardModule');
                        $ocLazyLoad.load({
                            name: 'app.DashBoardModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('activityExportCtrl', {
            url: '/activity-list-export',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/activity_export/views/activityExport.html'], function() {
                    let template = require('./app/activity_export/views/activityExport.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'activityExportCtrl',
            controllerAs: 'activityExportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/activity_export/activityExportModule.js');
                        $ocLazyLoad.load({
                            name: 'activityExportModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('schedulelo',{
            url:'/schedule/lo',
            templateProvider:['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/teacher_Evaluation/views/lo_schedule.html'], function() {
                    let template = require('./app/teacher_Evaluation/views/lo_schedule.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'lo_scheduleCrtl',
            controllerAs: 'lo_scheduleCrtl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/teacher_Evaluation/teacher_evaluation_mainModule.js');
                        $ocLazyLoad.load({
                            name: 'teacherEvaluationMainModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createLearningWalk', {
            url: '/learning/walk/create',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/learning_walk/views/createLearningWalk.html'], function() {
                    let template = require('./app/learning_walk/views/createLearningWalk.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createLearningWalk',
            controllerAs: 'createLearningWalk',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/learning_walk/learingModule.js');
                        $ocLazyLoad.load({
                            name: 'learningModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('createLessonObservation', {
            url: '/lesson/observation/create',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/lession_observation/views/createLessonObservation.html'], function() {
                    let template = require('./app/lession_observation/views/createLessonObservation.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'createLessonObservation',
            controllerAs: 'createLessonObservation',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/lession_observation/observationModule.js');
                        $ocLazyLoad.load({
                            name: 'lessionModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('timeTablePreview',{
            url:'/schedule/lo/timeTablePreview/:teacher_id/:teacher_name',
            templateProvider:['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/teacher_Evaluation/views/timeTablePreview.html'], function() {
                    let template = require('./app/teacher_Evaluation/views/timeTablePreview.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'timeTablePreview',
            controllerAs: 'timeTablePreview',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/teacher_Evaluation/teacher_evaluation_mainModule.js');
                        $ocLazyLoad.load({
                            name: 'teacherEvaluationMainModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('scheduledLoHistory',{
            url:'/schedule/lo/history',
            templateProvider:['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/teacher_Evaluation/views/scheduled_history.html'], function() {
                    let template = require('./app/teacher_Evaluation/views/scheduled_history.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'scheduledHistory',
            controllerAs: 'scheduledHistory',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/teacher_Evaluation/teacher_evaluation_mainModule.js');
                        $ocLazyLoad.load({
                            name: 'teacherEvaluationMainModule',
                            // files: [
                            //     './app/learning_walk/views/learning_walkHtml.html'
                            // ]
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('pdpCreateCtrl', {
            url: '/pdp/main',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/pdp/views/main.html'], function() {
                    let template = require('./app/pdp/views/main.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'pdpMainCtrl',
            controllerAs: 'pdpMainCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/pdp/pdpModule.js');
                        $ocLazyLoad.load({
                            name: 'pdpModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('schemeofwork',{
            url:"/schemeofwork/home",
            templateProvider:['$q',function($q){
                let deffered = $q.defer();
                require.ensure(['./app/scheme_of_work/views/home_page.html'],function(){
                    let template= require('./app/scheme_of_work/views/home_page.html')
                    deffered.resolve(template)
                })
                return deffered.promise
            }],
            controller:"homePageController",
            controllerAs:"homePageController",
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deffered = $q.defer()
                    require.ensure(['./app/scheme_of_work/controllers/home_page'],function(){
                        let module = require('./app/scheme_of_work/scheme_of_work_module')
                        $ocLazyLoad.load({
                            name:'schemeOfWorkModule'
                        })
                        deffered.resolve(module)
                    })
                    return deffered.promise
                }]
            }
        })
        .state('learningwalk',{
            url:'/learningwalk/home',
            templateProvider:['$q',function($q) {
                let deffered =$q.defer()
                require.ensure(['./app/new_learning_walk/views/home.html'],function() {
                    let template = require('./app/new_learning_walk/views/home.html')
                     deffered.resolve(template)
                })
                return deffered.promise
            }],
            controller:'learningWalkHome',
            controllerAs:'learningWalkHome',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deffered = $q.defer()
                    require.ensure(['./app/new_learning_walk/learning_walk_module.js'],function() {
                        let module = require('./app/new_learning_walk/learning_walk_module.js')
                        $ocLazyLoad.load({
                            name:"learningWalkModule"
                        })
                        deffered.resolve(module)
                    })
                    return deffered.promise
                }]
            }
        })
        .state('learningwalkcreate',{
            url:'/learningwalk/create',
            templateProvider:['$q',function($q) {
                let deffered =$q.defer()
                require.ensure(['./app/new_learning_walk/views/create.html'],function() {
                    let template = require('./app/new_learning_walk/views/create.html')
                     deffered.resolve(template)
                })
                return deffered.promise
            }],
            controller:'learningWalkCrtl',
            controllerAs:'learningWalkCrtl',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deffered = $q.defer()
                    require.ensure(['./app/new_learning_walk/learning_walk_module.js'],function() {
                        let module = require('./app/new_learning_walk/learning_walk_module.js')
                        $ocLazyLoad.load({
                            name:"learningWalkModule"
                        })
                        deffered.resolve(module)
                    })
                    return deffered.promise
                }]
            }
        })
        .state('learningwalkview',{
            url:'/learningwalk/view/:lw_id',
            templateProvider:['$q',function($q) {
                let deffered =$q.defer()
                require.ensure(['./app/new_learning_walk/views/view.html'],function() {
                    let template = require('./app/new_learning_walk/views/view.html')
                     deffered.resolve(template)
                })
                return deffered.promise
            }],
            controller:'learningWalkView',
            controllerAs:'learningWalkView',
            resolve:{
                foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
                    let deffered = $q.defer()
                    require.ensure(['./app/new_learning_walk/learning_walk_module.js'],function() {
                        let module = require('./app/new_learning_walk/learning_walk_module.js')
                        $ocLazyLoad.load({
                            name:"learningWalkModule"
                        })
                        deffered.resolve(module)
                    })
                    return deffered.promise
                }]
            }
        })
        .state('pdpMainCtrl', {
            url: '/pdp/home',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/pdp/views/home.html'], function() {
                    let template = require('./app/pdp/views/home.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'homeCrctl',
            controllerAs: 'homeCrctl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/pdp/pdpModule.js');
                        $ocLazyLoad.load({
                            name: 'pdpModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('pdpTeacherView', {
            url: '/pdp/home/:teacher_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/pdp/views/home.html'], function() {
                    let template = require('./app/pdp/views/home.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'homeCrctl',
            controllerAs: 'homeCrctl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/pdp/pdpModule.js');
                        $ocLazyLoad.load({
                            name: 'pdpModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('editpdp', {
            url: '/pdp/edit/:pdp_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/pdp/views/main.html'], function() {
                    let template = require('./app/pdp/views/main.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'pdpMainCtrl',
            controllerAs: 'pdpMainCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/pdp/pdpModule.js');
                        $ocLazyLoad.load({
                            name: 'pdpModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('viewpdp', {
            url: '/pdp/view/:pdp_id',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/pdp/views/view.html'], function() {
                    let template = require('./app/pdp/views/view.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'pdpViewCtrl',
            controllerAs: 'pdpViewCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/pdp/pdpModule.js');
                        $ocLazyLoad.load({
                            name: 'pdpModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        }) .state("principalQaurterlyReport",{
            url: '/principal/quarterly/report',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/quarterly_data/views/principal_report.html'], function() {
                    let template = require('./app/quarterly_data/views/principal_report.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'principalReportCrtl',
            controllerAs: 'principalReportCrtl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/quarterly_data/quarterlyDataModule.js');
                        $ocLazyLoad.load({
                            name: 'quarterlyDataModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('principal_synopsis',{
            url: '/quarterlyreport/data/entry/principal_synopsis',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/quarterly_data/views/principal_synopsis.html'], function() {
                    let template = require('./app/quarterly_data/views/principal_synopsis.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'principalSynopsisCrtl',
            controllerAs: 'principalSynopsisCrtl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/quarterly_data/quarterlyDataModule.js');
                        $ocLazyLoad.load({
                            name: 'quarterlyDataModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
		.state('previous_reports',{
            url: '/quarterlyreport/previous_reports',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/quarterly_data/views/quarterlyFeature.html'], function() {
                    let template = require('./app/quarterly_data/views/quarterlyFeature.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'previous_reports',
            controllerAs: 'previous_reports',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/quarterly_data/quarterlyDataModule.js');
                        $ocLazyLoad.load({
                            name: 'quarterlyDataModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
.state('rEutilsCtrls',{
            url: '/markentry/consolidated/view',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/utils/views/rEutils.html'], function() {
                    let template = require('./app/mark_entry/utils/views/rEutils.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'rEutilsCtrl',
            controllerAs: 'rEutilsCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry/utils/rEutilsModule.js');
                        $ocLazyLoad.load({
                            name: 'rEutilsModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('markEntryMonitorCtrls',{
            url: '/markentry/monitor/view',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/utils/views/markEntryMonitorCtrl.html'], function() {
                    let template = require('./app/mark_entry/utils/views/markEntryMonitorCtrl.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'markEntryMonitorCtrl',
            controllerAs: 'markEntryMonitorCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry/utils/rEutilsModule.js');
                        $ocLazyLoad.load({
                            name: 'rEutilsModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('hodReCtrl',{
            url: '/markentry/hod/view',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/utils/views/hodReCtrl.html'], function() {
                    let template = require('./app/mark_entry/utils/views/hodReCtrl.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'hodReCtrl',
            controllerAs: 'hodReCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry/utils/rEutilsModule.js');
                        $ocLazyLoad.load({
                            name: 'rEutilsModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('classTeacherReCtrl',{
            url: '/markentry/ct/view',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/utils/views/classTeacherReCtrl.html'], function() {
                    let template = require('./app/mark_entry/utils/views/classTeacherReCtrl.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classTeacherReCtrl',
            controllerAs: 'classTeacherReCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry/utils/rEutilsModule.js');
                        $ocLazyLoad.load({
                            name: 'rEutilsModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('scriptingCtrl',{
            url: '/script/run',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/scripting/views/sripting.html'], function() {
                    let template = require('./app/scripting/views/sripting.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'scriptingCtrl',
            controllerAs: 'scriptingCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/scripting/scriptingModule.js');
                        $ocLazyLoad.load({
                            name: 'scriptingModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
		.state('listMarkentryCtrl',{
            url: '/markentry/hod/view/list',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/utils/views/listMarkentry.html'], function() {
                    let template = require('./app/mark_entry/utils/views/listMarkentry.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'listMarkentryCtrl',
            controllerAs: 'listMarkentryCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/mark_entry/utils/rEutilsModule.js');
                        $ocLazyLoad.load({
                            name: 'rEutilsModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })


      .state('TransferredStudents', {
			url: '/transferred-students-list',
			templateProvider: ['$q', function($q) {
				let deferred = $q.defer();
				require.ensure(['./app/transferred/views/stud_list.html'], function() {
					let template = require('./app/transferred/views/stud_list.html');

					deferred.resolve(template);
				});
				return deferred.promise;
			}],
			controller: 'transferred_listCtrl',
			controllerAs: 'transferred_listCtrl',
			resolve: {
				foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
					let deferred = $q.defer();
					require.ensure([], function() {
						let module = require('./app/transferred/transfer_studmodule.js');
						$ocLazyLoad.load({
							name: 'TransferredStudentsModule'
						});
						deferred.resolve(module);
					});
					return deferred.promise;
				}]
			}
		}).state('classStoryColumnCtrl', {
            url: '/class/story/column',
            templateProvider: ['$q', function($q) {
                let deferred = $q.defer();
                require.ensure(['./app/cat-four/views/classStoryColumnController.html'], function() {
                    let template = require('./app/cat-four/views/classStoryColumnController.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classStoryColumnCtrl',
            controllerAs: 'classStoryColumnCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function() {
                        let module = require('./app/cat-four/classStoryColumnModule.js');
                        $ocLazyLoad.load({
                            name: 'classStoryColumnModule'
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
		.state('CsconsoleSettingCtrl', {
			url: '/set-column-catfour',
			templateProvider: ['$q', function($q) {
				let deferred = $q.defer();
				require.ensure(['./app/cat-four/views/set_column.html'], function() {
					let template = require('./app/cat-four/views/set_column.html');

					deferred.resolve(template);
				});
				return deferred.promise;
			}],
			controller: 'setColumn',
			controllerAs: 'setColumn',
			resolve: {
				foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
					let deferred = $q.defer();
					require.ensure([], function() {
						let module = require('./app/cat-four/setColumnModule.js');
						$ocLazyLoad.load({
							name: 'setColumn'
						});
						deferred.resolve(module);
					});
					return deferred.promise;
				}]
			}
		}).state('CsconsoleSettingTeacherCtrl', {
			url: '/set-column-catfour-teacher',
			templateProvider: ['$q', function($q) {
				let deferred = $q.defer();
				require.ensure(['./app/cat-four/views/set_column_teacher.html'], function() {
					let template = require('./app/cat-four/views/set_column_teacher.html');

					deferred.resolve(template);
				});
				return deferred.promise;
			}],
			controller: 'setColumnTeacher',
			controllerAs: 'setColumnTeacher',
			resolve: {
				foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
					let deferred = $q.defer();
					require.ensure([], function() {
						let module = require('./app/cat-four/setColumnTeacherModule.js');
						$ocLazyLoad.load({
							name: 'setColumnTeacher'
						});
						deferred.resolve(module);
					});
					return deferred.promise;
				}]
			}
		})
		.state('questionPaperCtrl', {
			url: '/question-paper',
			templateProvider: ['$q', function($q) {
				let deferred = $q.defer();
				require.ensure(['./app/qp_uploads/views/question_uploads.html'], function() {
					let template = require('./app/qp_uploads/views/question_uploads.html');
					deferred.resolve(template);
				});
				return deferred.promise;
			}],
			controller: 'questionPaperCtrl',
			controllerAs: 'questionPaperCtrl',
			resolve: {
				foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
					let deferred = $q.defer();
					require.ensure([], function() {
						let module = require('./app/qp_uploads/qustionpapermodule.js');
						$ocLazyLoad.load({
							name: 'questionPaperModule'
						});
						deferred.resolve(module);
					});
					return deferred.promise;
				}]
			}
		}).state('questionPaperTeacherCtrl', {
			url: '/teacher-question-paper',
			templateProvider: ['$q', function($q) {
				let deferred = $q.defer();
				require.ensure(['./app/qp_uploads/views/teacher-question_uploads.html'], function() {
					let template = require('./app/qp_uploads/views/teacher-question_uploads.html');
					deferred.resolve(template);
				});
				return deferred.promise;
			}],
			controller: 'questionPaperTeacherCtrl',
			controllerAs: 'questionPaperTeacherCtrl',
			resolve: {
				foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
					let deferred = $q.defer();
					require.ensure([], function() {
						let module = require('./app/qp_uploads/teacherqustionpapermodule.js');
						$ocLazyLoad.load({
							name: 'teacherQuestionPaperModule'
						});
						deferred.resolve(module);
					});
					return deferred.promise;
				}]
			}
		})
        

        .state('classTeacherReportCtrl', {
            url: '/markentry/exams/report/view',
            templateProvider: ['$q', function ($q) {
                let deferred = $q.defer();
                require.ensure(['./app/mark_entry/utils/views/classTeacherReportCtrl.html'], function () {
                    let template = require('./app/mark_entry/utils/views/classTeacherReportCtrl.html');
                    deferred.resolve(template);
                });
                return deferred.promise;
            }],
            controller: 'classTeacherReportCtrl',
            controllerAs: 'classTeacherReportCtrl',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    let deferred = $q.defer();
                    require.ensure([], function () {
                        let module = require('./app/mark_entry/utils/rEutilsModule.js');
                        $ocLazyLoad.load({
                            name: 'rEutilsModule',
                        });
                        deferred.resolve(module);
                    });
                    return deferred.promise;
                }]
            }
        })
        .state('qpPrincipalCtrl', {
			url: '/principal-question-paper',
			templateProvider: ['$q', function($q) {
				let deferred = $q.defer();
				require.ensure(['./app/qp_uploads/views/qpPrincipal.html'], function() {
					let template = require('./app/qp_uploads/views/qpPrincipal.html');
					deferred.resolve(template);
				});
				return deferred.promise;
			}],
			controller: 'qpPrincipalCtrl',
			controllerAs: 'qpPrincipalCtrl',
			resolve: {
				foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
					let deferred = $q.defer();
					require.ensure([], function() {
						let module = require('./app/qp_uploads/qpPrincipalModule.js');
						$ocLazyLoad.load({
							name: 'qpPrincipalModule'
						});

						deferred.resolve(module);
					});
					return deferred.promise;
				}]
			}
		})

        // .state('selectTeachers',{
        //     url: '/exampaper/select/teachers',
        //     templateProvider: ['$q', function($q) {
        //         let deferred = $q.defer();
        //         require.ensure(['./app/exampaper_selection/views/selectTeachers.html'], function() {
        //             let template = require('./app/exampaper_selection/views/selectTeachers.html');
        //             deferred.resolve(template);
        //         });
        //         return deferred.promise;
        //     }],
        //     controller: 'selectTeacherCrtl',
        //     controllerAs: 'selectTeacherCrtl',
        //     resolve: {
        //         foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
        //             let deferred = $q.defer();
        //             require.ensure([], function() {
        //                 let module = require('./app/exampaper_selection/exampaperModule');
        //                 $ocLazyLoad.load({
        //                     name: 'exampaperModule',
        //                 });
        //                 deferred.resolve(module);
        //             });
        //             return deferred.promise;
        //         }]
        //     }
        // })
        // Add new states above this loop
        stateArray.forEach((stateObj)=>{
            $stateProvider.state(stateObj._id,{
                url: '/quarterlyreport/data/entry/:type',
                templateProvider: ['$q', function($q) {
                    let deferred = $q.defer();
                    require.ensure(['./app/quarterly_data/views/view.html'], function() {
                        let template = require('./app/quarterly_data/views/view.html');
                        deferred.resolve(template);
                    });
                    return deferred.promise;
                }],
                controller: 'viewController',
                controllerAs: 'viewController',
                resolve: {
                    foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                        let deferred = $q.defer();
                        require.ensure([], function() {
                            let module = require('./app/quarterly_data/quarterlyDataModule.js');
                            $ocLazyLoad.load({
                                name: 'quarterlyDataModule',
                            });
                            deferred.resolve(module);
                        });
                        return deferred.promise;
                    }]
                }
            })
        })

 });







// WEBPACK FOOTER //
// ./src/stateModule.js